{
  "access.door.headline": "Ты рано.\nСнова.",
  "access.door.live": "Сейчас торгуется",
  "access.door.note": "Терминал открывается по приглашениям. Бот займёт тебе место в очереди и напишет, как только откроется.",
  "access.door.telegram": "Войти через Telegram",
  "access.door.title": "Только по приглашениям",
  "access.waitlist.check_again": "Проверить ещё раз",
  "access.waitlist.come_back_note": "Терминал открывается по приглашениям. Эта страница проверяет сама и откроет терминал, как только тебя впустят.",
  "access.waitlist.position": "Твоё место в очереди",
  "access.waitlist.share": "Твоя ссылка для друзей · пришли по ней: {{count}}",
  "access.waitlist.sign_out": "Выйти",
  "access.waitlist.telegram_note": "Терминал открывается по приглашениям. Напишем в Telegram, когда подойдёт твоя очередь.",
  "access.waitlist.title": "Ты в очереди",
  "analytics": "Аналитика",
  "analytics.tabs.info": "Инфо",
  "analytics.tabs.trades": "Трейды",
  "app-titlebar.forward": "Вперёд",
  "app-titlebar.maximize": "Развернуть",
  "app-titlebar.minimize": "Свернуть",
  "app-titlebar.open-in-browser": "Открыть в браузере",
  "app.name": "kol.trade",
  "app.pitch": "Скорость, простота, self-custody",
  "asset_few": "Актива",
  "asset_many": "Активов",
  "asset_one": "Актив",
  "asset_other": "Активы",
  "asset_zero": "Активов",
  "auth.access-denied": "Доступ запрещён",
  "auth.auth-login-account-description": "Вы получите доступ к торговым и другим функциям.",
  "auth.auth-login-account-title": "Чтобы начать торговать, войдите в аккаунт",
  "auth.continue": "Продолжить",
  "auth.create-local-password": "Создайте локальный пароль",
  "auth.create-pin-description": "Создайте пин-код для Вашей безопасности",
  "auth.create-pin-title": "Создайте Пин-код",
  "auth.enter_password_to_unlock": "<0>Введите пароль</0> чтобы продолжить",
  "auth.enter-otp-description": "Обнаружен вход с другого IP-адреса",
  "auth.enter-otp-title": "Введите OTP",
  "auth.forget-password": "Забыли пароль?",
  "auth.google-auth-error": "Не удалось войти с помощью Google",
  "auth.google-auth-error-existence-check": "Не удалось проверить существование пользователя",
  "auth.info.wallets": "Мы не храним доступ к вашим кошелькам на наших серверах. Разные устройства имеют разные кошельки и пароли.",
  "auth.invalid-otp": "Неверный OTP. Попробуйте ещё раз.",
  "auth.keychain-access-denied": "Не удалось получить доступ к хранилищу ключей",
  "auth.keychain-locked": "Хранилище заблокировано",
  "auth.log-in": "Войти",
  "auth.log-in-to-your-account": "Войдите в аккаунт или создайте его",
  "auth.log-out": "Выйти",
  "auth.login": "Войти",
  "auth.login-to-your-account": "Вход в аккаунт",
  "auth.login-with-another-account": "Вход с помощью другого аккаунта",
  "auth.login-with-google-loading": "Выполняем вход через Google...",
  "auth.login-with-telegram-loading": "Выполняем вход через Telegram...",
  "auth.login-with-username": "Вход с помощью логина",
  "auth.logout": "Выход",
  "auth.logout-message": "Вы уверены что хотите выйти?",
  "auth.me-request-error": "Не удалось получить информацию о пользователе",
  "auth.or-login-or-register": "или войти/зарегистрироваться через",
  "auth.password": "Пароль",
  "auth.please-wait": "Пожалуйста, подождите",
  "auth.please-wait-description": "мы получаем информацию о вашем аккаунте",
  "auth.register": "Зарегистрироваться",
  "auth.register.create-any-unique-username": "Создайте уникальный логин",
  "auth.register.create-any-unique-username-available": "<0> {{username}} доступен</0>",
  "auth.register.create-any-unique-username-checking": "<0> {{username}} проверяется</0>",
  "auth.register.create-any-unique-username-not-available": "<0> {{username}} недоступен</0>",
  "auth.register.enter-referral-code": "Введите реферальный код (необязательно)",
  "auth.register.terms-of-service": "Я согласен с <0>Условиями обслуживания</0> и <1>Политикой конфиденциальности</1>",
  "auth.registration": "Регистрация",
  "auth.repeat": "Повторите",
  "auth.sign-in": "Войти",
  "auth.twitter-auth-error": "Не удалось войти с помощью X",
  "auth.twitter-auth-error-existence-check": "Не удалось проверить существование пользователя",
  "auth.unlock": "Разблокировать",
  "auth.unlock-your-wallets": "Разблокируйте кошельки",
  "auth.username": "Логин",
  "auth.username-length-error": "Логин должен быть не менее 3 символов",
  "auth.username-not-available-error": "Логин уже занят",
  "auth.welcome": "Добро пожаловать",
  "auth.wrong-credentials": "Неверный логин или пароль. Попробуйте ещё раз.",
  "auth.wrong-password": "Неверный пароль",
  "back_office.premium.change_error": "Ошибка при переносе премиума на нового владельца",
  "back_office.premium.change_success": "Премиум успешно перенесён на нового владельца",
  "back_office.premium.id_or_token_required": "Укажите ID премиума или адрес токена",
  "back_office.premium.new_deluge_id": "kol.trade ID нового владельца",
  "back_office.premium.new_owner_wallet": "Адрес кошелька нового владельца",
  "back_office.premium.new_tg_id": "Telegram ID нового владельца",
  "back_office.premium.premium_id": "ID премиума",
  "back_office.premium.submit": "Перенести премиум",
  "back_office.premium.token_address": "Адрес токена",
  "back_office.user.active": "Активен",
  "back_office.user.block_user_confirm_block": "Вы уверены что хотите заблокировать {{name}}?",
  "back_office.user.block_user_confirm_unblock": "Вы уверены что хотите разблокировать {{name}}?",
  "back_office.user.blocked": "Заблокирован",
  "back_office.user.has_been_successfully_blocked": "Пользователь {{name}} был успешно заблокирован",
  "back_office.user.has_been_successfully_unblocked": "Пользователь {{name}} был успешно разблокирован",
  "back-office.navigation.title": "Админка",
  "back-office.table.wallets": "Кошельки",
  "basic.available": "Доступно {{amount}}",
  "basic.cash": "наличные",
  "basic.deposit_evm": "Ethereum, Base, BNB, Arbitrum",
  "basic.deposit_hint": "Отправьте USDC на один из этих адресов — сумма станет вашим балансом. Покупать можно в любой поддерживаемой сети.",
  "basic.deposit_solana": "Solana",
  "basic.deposit_title": "Пополнить баланс",
  "basic.deposit_more": "Пополнить",
  "basic.max": "Макс",
  "basic.no_positions": "Пока ничего нет",
  "basic.no_prices": "Цены недоступны",
  "basic.not_enough": "Недостаточно средств",
  "basic.nothing_held": "Нечего продавать",
  "basic.order_refused": "Заявка отклонена. Попробуйте ещё раз.",
  "basic.prices_as_of": "Цены {{when}}",
  "basic.prices_stale": "Цены {{when}} — могут быть устаревшими",
  "basic.quick_buy_accepted": "Заявка принята: {{amount}} на {{symbol}}",
  "basic.quick_buy_balance_unavailable": "Баланс сейчас не читается. Попробуйте через минуту.",
  "basic.quick_buy_not_enough": "Не хватает средств. Пополните баланс.",
  "basic.quick_buy_refused": "Покупка не прошла. Попробуйте ещё раз.",
  "basic.sell_percent": "Продать {{percent}}% {{symbol}}",
  "basic.unvalued": "Вложено {{cost}}",
  "basic.you_hold": "У вас {{amount}} {{symbol}}",
  "blacklist-currencies.description": "Токены из этого списка скрыты из вашей ленты Explore и результатов поиска. Откройте токен, чтобы он снова появился в ленте.",
  "blacklist-currencies.title": "Скрытые токены",
  "blacklist-currencies.unhide-tooltip": "Открыть токен",
  "blacklist.currencies.hide-tooltip": "Скрыть токен",
  "blacklist.currencies.tooltip": "Скрытые токены",
  "browser-mode.warning.big-title": "Внимание",
  "browser-mode.warning.button": "Подтвердить и продолжить",
  "browser-mode.warning.description": "Для максимальной безопасности кошелька настоятельно рекомендуется удалить или отключить все ненужные расширения браузера. Вредоносные или скомпрометированные расширения могут отслеживать активность или вмешиваться в выполнение транзакций. Оставляйте только те расширения, которым вы полностью доверяете и действительно используете.",
  "browser-mode.warning.heading": "Защитите свои кошельки",
  "browser-mode.warning.title": "Предупреждение",
  "bundler_few": "Бандлера",
  "bundler_many": "Бандлеров",
  "bundler_one": "Бандлер",
  "bundler_other": "Бандлера",
  "bundlers": "Бандлеры",
  "comment.add_comment": "Оставить комментарий",
  "comment.button_comments_few": "Показать ещё {{count}} комментария",
  "comment.button_comments_many": "Показать ещё {{count}} комментариев",
  "comment.button_comments_zero": "Показать ещё {{count}} комментариев",
  "comment.comment_created": "Ваш комментарий отправлен",
  "comment.comment_deleted": "Ваш комментарий удалён",
  "comment.comment_edited": "Ваш комментарий изменён",
  "comment.comments": "Комментарии",
  "comment.comments_all": "Все комментарии ({{count}})",
  "comment.comments_few": "Комментарии ({{count}})",
  "comment.comments_load_all": "Загрузить все комментарии ({{count}})",
  "comment.comments_many": "Комментарии ({{count}})",
  "comment.comments_one": "Комментарий ({{count}})",
  "comment.comments_other": "Комментарии ({{count}})",
  "comment.comments_zero": "Комментариев ({{count}})",
  "comment.delete.confirmation.description": "Это действие нельзя отменить.",
  "comment.delete.confirmation.title": "Вы уверены, что хотите удалить комментарий?",
  "comment.history.empty-description": "Комментарии будут появляться здесь",
  "comment.history.empty-title": "История комментариев пуста",
  "comment.image_attachment": "Вложенное изображение",
  "comment.message.delete": "Удалить",
  "comment.message.delete_as_admin": "Удалить как админ",
  "comment.message.edit": "Изменить",
  "comment.message.editing": "Изменение",
  "comment.message.hyped_users_only": "Комментировать могут только <icon /> <hyped>пользователи Hyped</hyped>",
  "comment.message.placeholder": "Ваш комментарий",
  "comment.message.reply": "Ответить",
  "comment.no_comments_description": "Оставьте комментарий первым",
  "comment.no_comments_title": "Пока нет комментариев",
  "comment.replies": "Ответы",
  "common.current": "Текущий",
  "common.30d": "30д",
  "common.30d-pnl": "30Д PnL",
  "common.5m-percent": "5M%",
  "common.action": "Действие",
  "common.action_need_confirmation": "Действие требует подтверждения",
  "common.activate": "Активировать",
  "common.activity": "Активность",
  "common.add": "Добавить",
  "common.add_file": "Добавить файл",
  "common.additional_information": "Дополнительная информация",
  "common.address": "Адрес",
  "common.age": "Возраст",
  "common.ago": "{{time}} назад",
  "common.all": "Все",
  "common.amount": "Сумма",
  "common.apply": "Применить",
  "common.at": "в",
  "common.ath": "ATH",
  "common.ath_mkt_cap": "ATH Кап.: {{value}}",
  "common.attention": "Внимание!",
  "common.audit": "Аудит",
  "common.auth": "Авторизация",
  "common.auto": "Авто",
  "common.avg-mc-bs": "Ср. MC П/П",
  "common.back": "Назад",
  "common.back-to-top": "Наверх",
  "common.bal": "Бал",
  "common.balance": "Баланс",
  "common.bought": "Куплено",
  "common.by": "От",
  "common.cancel": "Отменить",
  "common.change": "Изменить",
  "common.change-for-n": "Изменить за <n />",
  "common.check": "Проверить",
  "common.clear": "Очистить",
  "common.close": "Закрыть",
  "common.closed-price": "Цена Закрытия",
  "common.coins_few": "токена",
  "common.coins_held": "Удерживаемые токены",
  "common.coins_many": "токенов",
  "common.coins_one": "токен",
  "common.coins_other": "токены",
  "common.coins_zero": "токенов",
  "common.coming-soon": "Скоро будет доступно",
  "common.comments_few": "комментария",
  "common.comments_many": "комментариев",
  "common.comments_other": "комментарии",
  "common.comments_zero": "комментариев",
  "common.confirm": "Подтвердить",
  "common.connect": "Подключить",
  "common.continue": "Продолжить",
  "common.weekday.1": "Пн",
  "common.weekday.2": "Вт",
  "common.weekday.3": "Ср",
  "common.weekday.4": "Чт",
  "common.weekday.5": "Пт",
  "common.weekday.6": "Сб",
  "common.weekday.7": "Вс",
  "common.copied": "Скопировано",
  "common.copied-to-clipboard": "Скопировано в буфер обмена",
  "common.copy": "Копировать",
  "common.copy_address": "Копировать адрес",
  "common.copy-to-clipboard": "Скопировать",
  "common.cost": "Цена",
  "common.count": "Количество",
  "common.create": "Создать",
  "common.create_coin": "Создать монету",
  "common.created": "Создано",
  "common.created_at": "Создано",
  "common.created_coins": "Выпущенные монеты",
  "common.d-premium": "Premium",
  "common.date": "Дата",
  "common.day.zero": "дней",
  "common.days_few": "{{count}} дня",
  "common.days_many": "{{count}} дней",
  "common.days_one": "{{count}} день",
  "common.days_other": "{{count}} дня",
  "common.days_zero": "{{count}} дней",
  "common.description": "Описание",
  "common.dev_holdings": "Разраб. Удерживает",
  "common.dev_wallet": "Разраб. Кошелек",
  "common.dev-tokens": "Разраб. Токены",
  "common.disable": "Выключить",
  "common.disabled": "Выключено",
  "common.discord": "Discord",
  "common.dismiss": "Отменить",
  "common.done": "Готово",
  "common.download": "Скачать",
  "common.downloading": "Загрузка",
  "common.edit": "Изменить",
  "common.empty": "Пусто",
  "common.empty-unfortunately": "К сожалению, здесь пусто",
  "common.enabled": "Включено",
  "common.entry-price": "Цена Входа",
  "common.error": "Ошибка",
  "common.error-range-exceeded": "Минимальные значения не должны превышать максимальные",
  "common.example": "Пример",
  "common.expires": "Истекает",
  "common.explore": "Изучить",
  "common.explore-tokens": "Изучить токены",
  "common.export": "Экспорт",
  "common.fdv": "FDV",
  "common.file-size-too-big": "Размер файла слишком большой",
  "common.filter": "Фильтр",
  "common.filter_other": "Фильтры",
  "common.filter_reset": "Сбросить фильтр",
  "common.first_name": "Имя",
  "common.follow": "Подписаться",
  "common.follower_few": "Подписчика",
  "common.follower_many": "Подписчиков",
  "common.follower_one": "Подписчик",
  "common.follower_other": "Подписчиков",
  "common.follower_zero": "Подписчиков",
  "common.following_few": "подписки",
  "common.following_many": "подписки",
  "common.following_one": "подписка",
  "common.following_other": "подписки",
  "common.following_zero": "подписок",
  "common.format.days_short": "{{count}}д",
  "common.format.hours_short": "{{count}}ч",
  "common.format.minutes_short": "{{count}}м",
  "common.format.months_short": "{{count}}мес",
  "common.format.seconds_short": "{{count}}с",
  "common.format.weeks_short": "{{count}}н",
  "common.format.years_short": "{{count}}г",
  "common.funded": "Пополнено",
  "common.funded-amount": "Сумма пополнения",
  "common.funding": "Пополнение",
  "common.get_help": "Получить помощь",
  "common.globally": "глобально",
  "common.go-home": "Вернуться",
  "common.hash": "Хеш",
  "common.history": "История",
  "common.holders": "Холдеры",
  "common.holding": "Хранение",
  "common.holding-duration": "Время хранения",
  "common.hours_few": "{{count}} часа",
  "common.hours_many": "{{count}} часов",
  "common.hours_one": "{{count}} час",
  "common.hours_other": "{{count}} часа",
  "common.hours_zero": "{{count}} часов",
  "common.install": "Установить",
  "common.installation": "Установка",
  "common.invalid_input": "Неверные данные",
  "common.last_name": "Фамилия",
  "common.later": "Позже",
  "common.less": "Меньше",
  "common.likes_few": "лайка",
  "common.likes_many": "лайков",
  "common.likes_one": "лайк",
  "common.likes_other": "лайки",
  "common.likes_zero": "лайков",
  "common.liquidity": "Ликвидность",
  "common.loading": "Загрузка",
  "common.loading-error": "Ошибка во время загрузки",
  "common.locally": "локально",
  "common.loss": "Убыток",
  "common.max": "Макс.",
  "common.mcap-short": "КАП.",
  "common.mean": "Среднее",
  "common.mentions_few": "упоминания",
  "common.mentions_many": "упоминаний",
  "common.mentions_one": "упоминание",
  "common.mentions_other": "упоминания",
  "common.mentions_zero": "упоминаний",
  "common.min": "Мин.",
  "common.minutes": "Минуты",
  "common.mkt_cap": "Кап.",
  "common.more": "Больше",
  "common.more_info": "Больше информации",
  "common.n_a": "Н/Д",
  "common.n-left": "{{n}} осталось",
  "common.name": "Название",
  "common.next": "Дальше",
  "common.no": "Нет",
  "common.no_data": "Нет данных",
  "common.no-data-found": "Данные Не Найдены",
  "common.no-data-try-change-filters": "Попробуйте поменять фильтры или запрос",
  "common.no-items": "Ничего",
  "common.no-items-found": "Ничего не найдено",
  "common.no-recommendations": "Рекомендации не найдены",
  "common.no-results": "Результаты не найдены",
  "common.no-results-found-for": "По запросу \"{{query}}\" ничего не найдено",
  "common.not-a-single-match-was-found": "Совпадений не найдено",
  "common.now": "Сейчас",
  "common.of": "из",
  "common.open": "Открыть",
  "common.open_app": "Открыть Приложение",
  "common.optional": "Необязательно",
  "common.or": "или",
  "common.page-not-found": "Страница Не Найдена",
  "common.pair_few": "пары",
  "common.pair_many": "пар",
  "common.pair_zero": "пар",
  "common.paste": "Вставить",
  "common.paused": "На паузе",
  "common.period.12h": "12ч",
  "common.period.1d": "1д",
  "common.period.1h": "1ч",
  "common.period.5m": "5м",
  "common.period.6h": "6ч",
  "common.period.7d": "7д",
  "common.period.all": "Все",
  "common.ping": "Пинг",
  "common.pnl": "PnL",
  "common.pnl-total": "Всего PnL",
  "common.position": "Позиция",
  "common.position-share": "Доля позиции",
  "common.premium": "Премиум",
  "common.price": "Цена",
  "common.process": "Загрузить",
  "common.processing": "В процессе",
  "common.profile": "Профиль",
  "common.profit": "Прибыль",
  "common.realized": "Реализовано",
  "common.reason": "Причина",
  "common.recent": "Недавнее",
  "common.refresh": "Обновить",
  "common.relaunch": "Перезагрузить",
  "common.reload": "Перезагрузить",
  "common.remove": "Удалить",
  "common.report": "Репорт",
  "common.repository_few": "репозитория",
  "common.repository_many": "репозиториев",
  "common.repository_one": "репозиторий",
  "common.repository_other": "репозиториев",
  "common.repository_zero": "репозиториев",
  "common.retry": "Повторить",
  "common.save": "Сохранить",
  "common.saved": "Сохранено",
  "common.search": "Искать",
  "common.searching": "Поиск",
  "common.select-all": "Выбрать все",
  "common.selected": "Выбрано",
  "common.selected_few": "Выбрано",
  "common.selected_many": "Выбрано",
  "common.selected_one": "Выбран",
  "common.selected_other": "Выбрано",
  "common.send": "Отправить",
  "common.share": "Поделиться",
  "common.sold": "Продано",
  "common.something_went_wrong_try_again": "Что-то пошло не так. Попробуйте ещё раз позже",
  "common.something-went-wrong": "Что-то пошло не так",
  "common.sort": "Сортировка",
  "common.status": "Статус",
  "common.supply": "Циркуляция",
  "common.symbol": "Символ",
  "common.telegram": "Telegram",
  "common.theme": "Тема",
  "common.total": "Всего",
  "common.total-invested": "Всего Куплено",
  "common.total-profit": "Прибыль",
  "common.total-sold": "Всего Продано",
  "common.total-tokens-holding": "Всего токенов",
  "common.trending-tokens-will-be-available-soon": "Трендовые токены скоро будут доступны",
  "common.try-again": "Попробовать ещё раз",
  "common.try-changing-search-query": "Попробуйте изменить запрос",
  "common.twitter": "X",
  "common.tx_char": "ТР",
  "common.txs": "ТР",
  "common.type": "Тип",
  "common.unfollow": "Отписаться",
  "common.unfortunately": "К сожалению",
  "common.unrealized-profit": "Нереализованная прибыль",
  "common.unselect-all": "Очистить",
  "common.until": "до",
  "common.update": "Обновить",
  "common.updated_at": "Обновлено",
  "common.upnl": "uPnL",
  "common.upnl-tooltip": "Нереализованная Прибыль и Убыток",
  "common.user_one": "Пользователь",
  "common.user_other": "Пользователей",
  "common.user_reported_successfully": "Репорт отправлен успешно",
  "common.username": "Логин",
  "common.users": "Пользователи",
  "common.version": "Версия",
  "common.view_all": "Смотреть все",
  "common.volume": "Объём",
  "common.volume_char": "О",
  "common.volume_short": "Объ.",
  "common.wallets": "Кошельки",
  "common.website": "Вебсайт",
  "common.who_to_follow": "Рекомендации для подписки",
  "common.win-rate": "Винрейт",
  "common.withdraw": "Вывести",
  "common.yes": "Да",
  "common.you": "Вы",
  "create-password": "Создать Пароль",
  "currency.age-minutes": "Возраст токена (мин)",
  "currency.audit.caution": "Предупреждение",
  "currency.audit.risky": "Опасно",
  "currency.audit.safe": "Безопасно",
  "currency.create-cta": "Создать токен",
  "currency.create-subtip": "When your token completes you will receive <0>0.5 SOL</0>",
  "currency.create-tip": "Информация токена не может быть изменена после создания",
  "currency.create-token": "Создать токен",
  "currency.duplicates.reused-icons": "Повторные изображения токенов",
  "currency.duplicates.see-more": "Перейдите на страницу токена, чтобы увидеть полный список",
  "currency.duplicates.similar-names": "Токены с похожим названием",
  "currency.edit_the_token_details": "Редактировать Детали Токена",
  "currency.edit_token": "Редактировать токен",
  "currency.logo.restricted": "Ограничено",
  "currency.logo.restricted-tooltip": "Логотип токена не прошёл модерацию",
  "currency.search_ticker_token_or_address": "Ищите с помощью символа, названия или адреса токена",
  "currency.search_token_or_address": "Искать токен или адрес",
  "currency.search-address": "Искать адрес {{ticker}} в X",
  "currency.search-token": "Искать токен",
  "currency.select_currency": "Выберите Токен",
  "currency.select-currency": "Выберите токен",
  "currency.token_address_copied_message": "{{ticker}} адрес токена скопирован!",
  "currency.token_address_copy_tooltip": "Копировать адрес токена",
  "currency.token-address": "Адрес токена",
  "currency.view_token_page": "Перейти на страницу токена",
  "deep-link.download-dialog.continue-on-website": "Продолжить в браузере",
  "deep-link.download-dialog.download-app": "Скачать Приложение",
  "deep-link.download-dialog.open-in-app": "Открыть в Приложении",
  "deep-link.download-dialog.title": "Скачать десктопное приложение",
  "deep-link.unsafe-url-dialog.description": "Вы собираетесь открыть потенциально опасную ссылку. Пожалуйста, будьте осторожны и переходите только в том случае, если уверены в источнике.",
  "deposit": "Депозит",
  "dev-tokens": "Dev Токены",
  "dev-tokens.ath-mc": "ATH Кап.",
  "dev-tokens.dev": "DEV",
  "dev-tokens.highlights": "Хайлайты",
  "dev-tokens.last-token-launched": "Последний токен",
  "dev-tokens.migrated": "Мигрировано",
  "dev-tokens.no-tokens.description": "Разрботчик не создавал других токенов",
  "dev-tokens.no-tokens.title": "Нет токенов",
  "dev-tokens.not-migrated": "Не мигрировано",
  "dev-tokens.token-stats": "Статистика токена",
  "dev-tokens.total-pairs": "Всего пар",
  "error.auth.invalid-credentials": "Недействительные учетные данные",
  "error.auth.invalid-otp": "Недействительный OTP",
  "error.auth.invalid-token": "Недействительный токен",
  "error.auth.inviter-not-found": "Пользователь не найден",
  "error.auth.otp-required": "Требуется OTP",
  "error.auth.unauthorized": "Неавторизован",
  "error.auth.user-already-exists": "Пользователь уже существует",
  "error.auth.user-not-found": "Пользователь не найден",
  "error.fastify.content-body-too-large": "Слишком большой объем содержимого",
  "error.position.balance-not-found": "Баланс не найден {{amount}} {{ticker}} #id{{id}}",
  "error.position.bundle-missing-signatures": "В пакете отсутствуют подписи {{amount}} {{ticker}} #id{{id}}",
  "error.position.bundle-not-landed": "Пакет не доставлен {{amount}} {{ticker}} #id{{id}}",
  "error.position.bundle-wrong-transaction": "Пакет имеет неверную транзакцию {{amount}} {{ticker}} #id{{id}}",
  "error.position.dex-not-supported": "DEX не поддерживается {{amount}} {{ticker}} #id{{id}}",
  "error.position.insufficient-balance": "Недостаточно средств {{amount}} {{ticker}} #id{{id}}",
  "error.position.insufficient-reserves": "Недостаточно резервов {{amount}} {{ticker}} #id{{id}}",
  "error.position.pool-info-not-found": "Информация о пуле не найдена {{amount}} {{ticker}} #id{{id}}",
  "error.position.swap-data-not-found": "Данные обмена не найдены {{amount}} {{ticker}} #id{{id}}",
  "error.position.swap-not-created": "Обмен не создан {{amount}} {{ticker}} #id{{id}}",
  "error.position.tips-account-not-found": "Аккаунт для чаевых не найден {{amount}} {{ticker}} #id{{id}}",
  "error.position.unsupported-provider": "Провайдер не поддерживается {{amount}} {{ticker}} #id{{id}}",
  "error.premium.expire-time-more-than-7-days": "Срок действия более 7 дней",
  "error.premium.image-content-not-safe": "Содержимое изображения небезопасно",
  "error.premium.image-safety-check-failed": "Проверка безопасности изображения не пройдена",
  "error.premium.no-processing-boosters": "Нет обрабатываемых бустеров",
  "error.premium.not-enough-paid": "Недостаточно оплачено",
  "error.premium.premium-already-purchased": "Премиум уже приобретен",
  "error.premium.premium-not-found": "Премиум не найден",
  "error.premium.transaction-not-found": "Транзакция не найдена",
  "error.referral.referral-code-must-be-unique": "Реферальный код должен быть уникальным",
  "error.referral.this-referral-code-already-exists": "Такой реферальный код уже существует",
  "error.secure-storage.already-exists-address": "Этот адрес уже существует",
  "error.secure-storage.decryption-failed": "Не удалось расшифровать данные",
  "error.secure-storage.desynced": "Локальное хранилище рассинхронизировано с сохранёнными ключами. Войдите заново, чтобы восстановить доступ.",
  "error.secure-storage.internal-error": "Произошла внутренняя ошибка",
  "error.secure-storage.invalid-deluge-id": "Недействительный kol.trade ID",
  "error.secure-storage.invalid-encryption-key": "Ключ шифрования недействителен",
  "error.secure-storage.not-found": "Не удалось найти запрашиваемый элемент",
  "error.secure-storage.sign-permit-error": "Не удалось подписать данные разрешения",
  "error.secure-storage.storage-error": "Ошибка безопасного хранилища",
  "error.secure-storage.storage-is-already-initialized": "Безопасное хранилище уже настроено",
  "error.secure-storage.storage-is-locked": "Безопасное хранилище заблокировано",
  "error.secure-storage.storage-is-unlocked": "Безопасное хранилище разблокировано",
  "error.secure-storage.store-error": "Не удалось сохранить данные",
  "error.secure-storage.unable-to-derive-key-from-password": "Не удалось сгенерировать ключ из заданного пароля",
  "error.secure-storage.wrong-network": "Подключено к неправильной сети",
  "error.secure-storage.wrong-password": "Введён неверный пароль",
  "error.services.infura-not-responding": "Infura не отвечает",
  "error.services.not-enough-liquidity": "Недостаточно ликвидности",
  "error.services.pair-not-found": "Пара не найдена",
  "error.services.pool-address-invalid": "Адрес пула недействителен",
  "error.services.pool-fetch-failed": "Не удалось получить пул",
  "error.services.pool-not-found": "Пул не найден",
  "error.services.pools-fetch-failed": "Не удалось получить пулы",
  "error.services.position-not-found": "Позиция не найдена",
  "error.services.signature-required": "Требуется подпись",
  "error.services.swap-not-found": "Обмен не найден",
  "error.services.token-address-invalid": "Адрес токена недействителен",
  "error.services.token-address-required": "Требуется адрес токена",
  "error.services.token-not-found": "Токен не найден",
  "error.services.transaction-failed": "Транзакция не удалась",
  "error.trade.allowance-not-fetched": "Не удалось получить allowance",
  "error.trade.approve-insufficient-funds": "Недостаточно средств для одобрения",
  "error.trade.create-swap-transaction": "Не удалось создать транзакцию обмена",
  "error.trade.database": "Общая ошибка базы данных",
  "error.trade.invalid-amount": "Неверная сумма",
  "error.trade.no-active-position": "Нет активной позиции",
  "error.trade.not-supported-provider": "Не поддерживаемый провайдер",
  "error.trade.required-argument-missing": "Необходимый аргумент отсутствует",
  "error.trade.swap-insufficient-funds": "Недостаточно средств для обмена",
  "error.trade.swap-order-not-found": "Заказ обмена не найден",
  "error.trade.transaction-missing": "Транзакция отсутствует",
  "error.trade.transaction-send": "Не удалось отправить транзакцию",
  "error.trade.unsupported-network": "Не поддерживаемая сеть",
  "error.user.otp-required": "Требуется OTP",
  "error.wallet.asset-already-added": "Актив уже добавлен",
  "error.wallet.device-wallet": "Этот кошелек хранится на вашем устройстве, ключ есть только там",
  "error.wallet.invalid-private-key": "Это не приватный ключ",
  "error.wallet.no-route": "Не нашли, как провести эту сделку",
  "error.wallet.router-unavailable": "Сейчас торговля недоступна",
  "error.wallet.keys-unavailable": "Сейчас здесь нельзя создать кошелек",
  "error.wallet.wallet-already-added": "Кошелек уже добавлен",
  "error.wallet.wallet-not-found": "Кошелек не найден #id{{id}}",
  "error.wallet.wallet-sign-error": "Ошибка подписи кошелька",
  "explore.ranked-by": "Ранжирование",
  "explore.cooking": "Готовящиеся",
  "explore.developer-swap-tooltip.buy": "Разраб. Купил",
  "explore.developer-swap-tooltip.sell": "Разраб. Продал",
  "explore.developer-swap-tooltip.sold-all": "Продал Всё",
  "explore.developer-tokens-tooltip.bonded": "Мигрировавшие",
  "explore.developer-tokens-tooltip.created": "Создано",
  "explore.developer-tokens-tooltip.created-7d": "Создано (7д)",
  "explore.developer-tokens-tooltip.top-tokens": "Топ Токенов",
  "explore.developer-tokens.24h-traders": "24ч трейдеров",
  "explore.graduated": "Мигрировавшие",
  "explore.sort.created-at": "Создан",
  "explore.sort.gain-score": "Gain Score",
  "explore.sort.holders-change-percent": "Изменение Холдеров",
  "explore.sort.holders-count": "Холдеры",
  "explore.sort.tx-count": "Транзакции",
  "explore.trending-gainers": "Растущие",
  "explore.trending-tokens": "Трендовые",
  "fun.created-by": "Создан",
  "fun.explore.create-token": "Создать Токен",
  "fun.explore.description": "Create your own coins, sell them on our platform and create capital.",
  "fun.explore.title": "Deluge.fun",
  "fun.find_best": "find the best tokens that already exist.",
  "fun.launched_time": "Время запуска",
  "fun.listed_on_deluge": "Listed on Deluge",
  "fun.search_placeholder": "Введите символ, название или адрес токена",
  "fun.ticker": "Тикер",
  "fun.top_tokens_title": "Топ токенов на Deluge.fun",
  "gas-settings": "Настройки Газа",
  "gas-settings.base-fee": "Базовая комиссия",
  "gas-settings.change-gas-settings": "Изменить настройки газа",
  "gas-settings.congestion.high": "Нагруженное",
  "gas-settings.congestion.low": "Хорошее",
  "gas-settings.congestion.stable": "Стабильное",
  "gas-settings.estimated-fee": "Ожидаемая комиссия",
  "gas-settings.gas-cost": "цена газа",
  "gas-settings.gas-option": "Настройка газа",
  "gas-settings.help-line-1": "Хотели бы Вы",
  "gas-settings.help-line-2": "о газе?",
  "gas-settings.help-line-link": "узнать больше",
  "gas-settings.max-fee": "Макс. комиссия",
  "gas-settings.network-status": "Состояние Сети",
  "gas-settings.option.advanced": "Дополнительно",
  "gas-settings.option.high": "Агрессивно",
  "gas-settings.option.low": "Медленно",
  "gas-settings.option.market": "Обычно",
  "gas-settings.priority-fee": "Приоритетная комиссия",
  "gas-settings.time": "Время",
  "gas-settings.tooltip-description.advanced": "Используйте <b>{{label}}</b> чтобы редактировать цену газа. Это может быть непонятным если Вы не знакомы с этим. Используйте на свой страх и риск.",
  "gas-settings.tooltip-description.high": "Высокий шанс, даже на волатильном рынке. Используйте <b>{{label}}</b> для покрытия всплеска активности, таких как выходы крупных NFT коллекций.",
  "gas-settings.tooltip-description.low": "Используйте <b>{{label}}</b> чтобы ждать более дешёвой цены. Примерное время неточно, потому что цены непредсказуемы.",
  "gas-settings.tooltip-description.market": "Используйте <b>{{label}}</b> для обработки по текущим рыночным ценам.",
  "gas-settings.variant.advanced": "Расширенный",
  "gas-settings.variant.high": "Агрессивно",
  "gas-settings.variant.low": "Медленно",
  "gas-settings.variant.market": "Обычно",
  "holder_few": "Холдера",
  "holder_many": "Холдеров",
  "holder_other": "Холдеры",
  "holder_zero": "Холдеров",
  "initial.loading_error": "Ошибка Загрузки",
  "insider_few": "Инсайдера",
  "insider_many": "Инсайдеров",
  "insider_one": "инсайдер",
  "insider_other": "Инсайдера",
  "insiders": "Инсайдеры",
  "instant-trade.swap-buttons.saved": "Кнопки моментального трейда были успешно сохранены",
  "language": "Язык",
  "language.bg": "Болгарский",
  "language.bs": "Боснийский",
  "language.cs": "Чешский",
  "language.da": "Датский",
  "language.de": "Немецкий",
  "language.el": "Греческий",
  "language.en": "Английский",
  "language.es": "Испанский",
  "language.et": "Эстонский",
  "language.fi": "Финский",
  "language.fr": "Французский",
  "language.hr": "Хорватский",
  "language.hu": "Венгерский",
  "language.it": "Итальянский",
  "language.lt": "Литовский",
  "language.lv": "Латышский",
  "language.mk": "Македонский",
  "language.nl": "Нидерландский",
  "language.no": "Норвежский",
  "language.pl": "Польский",
  "language.pt": "Португальский",
  "language.ro": "Румынский",
  "language.ru": "Русский",
  "language.sk": "Словацкий",
  "language.sl": "Словенский",
  "language.sq": "Албанский",
  "language.sr": "Сербский",
  "language.sv": "Шведский",
  "language.tr": "Турецкий",
  "language.uk": "Украинский",
  "latency.average": "Среднее",
  "latency.bad": "Плохое",
  "latency.connected": "Подключено",
  "latency.disconnected": "Отключено",
  "latency.disconnected.description": "Соединение с сервером потеряно.",
  "latency.good": "Хорошее",
  "leaderboard.dont_have_rank": "У вас еще нет ранга",
  "leaderboard.place": "месте",
  "leaderboard.user_names": "Логин",
  "leaderboard.you_are_in": "Вы на",
  "limit_order.status_active": "Активный",
  "limit_order.status_cancelled": "Отменён",
  "limit_order.status_completed": "Выполнен",
  "limit_order.status_expired": "Истёк",
  "limit_order.status_failed": "Неудачный",
  "maker_few": "Мейкера",
  "maker_many": "Мейкеров",
  "maker_one": "Мейкер",
  "maker_zero": "Мейкеров",
  "maker.30d-win-rate": "30Д Винрейт",
  "maker.size.description.dolphin": "Дельфин: $1k-$10k куплено или продано",
  "maker.size.description.fish": "Рыба: <$250 куплено или продано",
  "maker.size.description.shrimp": "Креветка: $250-$1k куплено или продано",
  "maker.size.description.whale": "Кит: $10k+ куплено или продано",
  "maker.size.dolphin": "Дельфин",
  "maker.size.fish": "Рыба",
  "maker.size.shrimp": "Креветка",
  "maker.size.whale": "Кит",
  "maker.tag.bundler.tooltip": "Бандлер",
  "maker.tag.fresh.tooltip": "Новый кошелек",
  "maker.tag.insider.tooltip": "Инсайдер",
  "maker.tag.sniper.tooltip": "Снайпер",
  "maker.volume-tooltip": "{{amount}} куплено или продано",
  "market-cap": "Капитализация",
  "mfa.code_copied_message": "Код скопирован!",
  "mfa.copy_key": "Копировать ключ",
  "mfa.instruction_line_1": "Установите приложение для аутентификации. Мы рекомендуем установить Duo Mobile или Google Authenticator, если у Вас его ещё нет.",
  "mfa.instruction_line_2": "Введите код в приложении или отсканируйте QR код.",
  "mfa.instruction_line_3": "Как только приложение сгенерирует код, введите его здесь",
  "mfa.mfa_successfully_set_message": "Двухфакторная аутентификация успешно установлена!",
  "mfa.mfa-removed.message": "Двухфакторная Аутентификация была отключена",
  "mfa.qr_core": "QR Код",
  "mfa.remove-mfa-confirm-message": "Отключение двухфакторной аутентификации уберёт дополнительный слой защиты Вашего аккаунта. Это означает что не нужно будет вводить код верификации во время подозрительных попыток входа. Мы рекомендуем оставить включённым для дополнительной защиты. Вы хотите продолжить?",
  "mfa.remove-mfa-title": "Отключить Двухфакторную Аутентификацию",
  "mfa.setup_authenticator_note": "Откройте Ваше приложение для аутентификации и выберите сканирование QR кода. Затем, используйте 6-значный код для завершения настройки.",
  "mfa.setup_instructions": "Инструкция По Установке",
  "mfa.two_factory_auth": "Двухфакторная аутентификация",
  "navigation.favorite": "Избранное",
  "navigation.login": "Логин",
  "navigation.portfolio": "Портфолио",
  "navigation.wallet-tracker": "Трекер",
  "network-data.priority-fee-tooltip": "Приоритетная Комиссия: {{amount}} {{ticker}}",
  "new-pairs": "Новые Пары",
  "nft.collection.all": "Все",
  "nft.collection.apply-changes": "Применить изменения",
  "nft.collection.collection-preview": "Предпросмотр коллекции",
  "nft.collection.default-description": "Опишите вашу коллекцию здесь. Добавьте больше деталей, чтобы помочь пользователям и маркетплейсам понять, что делает эту коллекцию уникальной и интересной.",
  "nft.collection.default-name": "Моя NFT коллекция",
  "nft.collection.grid-size": "Размер сетки",
  "nft.collection.item-details": "Детали элемента",
  "nft.collection.layer-name": "Название слоя",
  "nft.collection.randomize": "Рандомизировать",
  "nft.collection.select-properties-to-edit": "Выберите свойства для редактирования:",
  "nft.collection.select-trait": "Выберите характеристику",
  "nft.collection.used-in-items": "Используется в {{count}} элементах {{rarity}}%",
  "nft.edit.collection": "Коллекция",
  "nft.edit.properties": "Свойства",
  "nft.group.accessories": "Аксессуары",
  "nft.group.background": "Фон",
  "nft.group.body": "Тело",
  "nft.group.eyes": "Глаза",
  "nft.group.face": "Лицо",
  "nft.group.hair": "Волосы",
  "nft.groups.create-group": "Создать группу",
  "nft.groups.create-new": "Создать новую",
  "nft.groups.default-name-prefix": "Группа",
  "nft.groups.enter-name": "Введите название",
  "nft.library.add-rule": "Добавить правило",
  "nft.library.all-images": "Все изображения",
  "nft.library.all-traits": "Все характеристики",
  "nft.library.delete-all": "Удалить всё",
  "nft.library.delete-group": "Удалить группу",
  "nft.library.delete-trait": "Удалить характеристику",
  "nft.library.empty.subtitle": "уникальную NFT-коллекцию для продажи",
  "nft.library.empty.title": "Начните создавать свою",
  "nft.library.notes.first-author": "Каждый первый автор получает около $1,000<0>от продажи своей коллекции.</0>",
  "nft.library.notes.second-author": "Каждый второй автор получает около $2,000<0>от продажи своей коллекции.</0>",
  "nft.library.notes.third-author": "Каждый третий автор получает около $3,000<0>от продажи своей коллекции.</0>",
  "nft.library.rules-description": "Правило позволяет блокировать или принудительно сопоставлять определенные характеристики. Если у вас слишком много правил, рассмотрите возможность использования расширенного режима.",
  "nft.library.sort-by": "Сортировать по",
  "nft.library.trait-name": "Название характеристики",
  "nft.library.trait-search-placeholder": "Поиск характеристики",
  "nft.library.usage": "Использование",
  "nft.messages.all-cleared": "Все группы, характеристики и правила были очищены. Ваш NFT-проект теперь сброшен.",
  "nft.messages.collection-published": "Коллекция опубликована",
  "nft.messages.group-created": "Группа создана",
  "nft.messages.group-deleted": "Группа удалена",
  "nft.messages.image-removed": "Изображение удалено",
  "nft.messages.rules-cleared": "Правила очищены",
  "nft.messages.trait-already-exists": "Характеристика уже существует",
  "nft.messages.trait-removed": "Характеристика удалена",
  "nft.nav.groups": "Группы",
  "nft.navigation.edits": "Редактирование",
  "nft.navigation.generate": "Сгенерировать",
  "nft.navigation.library": "Библиотека",
  "nft.navigation.publish": "Опубликовать",
  "nft.processing.cancel": "Отмена",
  "nft.processing.creating-collection": "Создание вашей коллекции",
  "nft.publish.choose-collection-avatar": "Выберите аватар коллекции",
  "nft.publish.preview-on-marketplace": "Посмотреть на маркетплейсе",
  "nft.publish.publish-collection": "Опубликовать коллекцию",
  "nft.rarity.default": "По умолчанию",
  "nft.rarity.label-rare": "Редкая 16-25%",
  "nft.rarity.label-rarest": "Самая редкая 6-15%",
  "nft.rarity.label-regular": "Обычная",
  "nft.rarity.label-unique": "Уникальная 1-5%",
  "nft.rarity.ordinary": "обычная",
  "nft.rarity.rarity": "Редкость",
  "nft.rarity.short": "Р:",
  "nft.settings.clear-all": "Очистить всё",
  "nft.settings.description": "Описание",
  "nft.settings.height": "Высота",
  "nft.settings.how-it-works": "Как это работает?",
  "nft.settings.name": "Название",
  "nft.settings.reset-to-default": "Сбросить по умолчанию",
  "nft.settings.save": "Сохранить",
  "nft.settings.size": "Размер",
  "nft.settings.title": "Настройки",
  "nft.settings.width": "Ширина",
  "nft.single-image-tab.added": "Добавлены",
  "nft.single-image-tab.rules": "Правила",
  "nft.sort-by.date": "Дата",
  "nft.sort-by.name": "Название",
  "nft.sort-by.rarity": "Редкость",
  "nft.start-tab.images": "Изображения",
  "nft.start-tab.rarity-settings": "Настройки редкости",
  "nft.upload.open-to-upload": "Откройте для загрузки новых файлов",
  "nft.upload.open-to-upload-expanded": "<0>Нажмите или перетащите изображения сюда!</0>png, максимальный размер файла: 2 МБ на изображение",
  "notification-center.active_wallets_few": "{{count}} активных кошелька",
  "notification-center.active_wallets_many": "{{count}} активных кошельков",
  "notification-center.active_wallets_one": "{{count}} активный кошелёк",
  "notification-center.active_wallets_other": "{{count}} активных кошельков",
  "notification-center.additional_widgets_view": "Вид общих виджетов",
  "notification-center.last_transactions": "Последние транзакции",
  "notification-center.my_profile": "Мой профиль",
  "notification-center.notifications": "Уведомления",
  "notification-center.personal_widgets": "Личные виджеты",
  "notification-center.reorder_widget": "Изменить порядок виджета",
  "notification-center.save_changes": "Сохранить изменения",
  "notification-center.set_widgets": "Настроить виджеты",
  "notification-center.shared_widgets": "Общие виджеты",
  "notification-center.updates_few": "{{count}} обновления",
  "notification-center.updates_many": "{{count}} обновлений",
  "notification-center.updates_one": "{{count}} обновление",
  "notification-center.updates_other": "{{count}} обновлений",
  "notification-center.widgets_settings_changed": "Настройки виджетов изменены",
  "onboarding-dialog.boosting-terms": "Бустинг",
  "onboarding-dialog.confirm": "Я подтверждаю и соглашаюсь",
  "onboarding-dialog.description": "Вы можете запускать и торговать токенами здесь.<0/>Продолжая, <1>вы подтверждаете, что вам 18+ и принимаете наши Условия использования.</1>",
  "onboarding-dialog.disclaimer": "Дисклеймер",
  "onboarding-dialog.privacy-policy": "Конфиденциальность",
  "onboarding-dialog.terms-of-service": "Условия обслуживания",
  "onboarding-dialog.title": "Создавайте и Торгуйте!",
  "onboarding-dialog.welcome": "Добро пожаловать!",
  "onboarding.story-viewer-aria-label": "Просмотр историй",
  "order_few": "Ордера",
  "order_many": "Ордеров",
  "order_other": "Ордеры",
  "order_zero": "Ордеров",
  "order.active-order_few": "Активных ордера",
  "order.active-order_many": "Активных ордеров",
  "order.active-order_one": "Активный ордер",
  "order.active-order_other": "Активные ордеры",
  "order.active-order_zero": "Активных ордеров",
  "order.all-orders": "Все ордера",
  "order.cancel-all": "Отменить все",
  "order.cancel-all-confirm.description": "Вы уверены что хотите отменить все активные ордера?",
  "order.cancel-all-confirm.title": "Отменить все ордера",
  "order.close-order-completed": "Ордер был закрыт",
  "order.close-order-confirm-description": "Закрывая этот лимитный ордер, он больше не сработает когда условия срабатывания подходят. Если Вы всё ещё хотите торговать при определённой цене, Вам нужно будет создать новый лимитный ордер. Подтвердите для продолжения.",
  "order.close-order-confirm-title": "Вы уверены, что хотите закрыть лимитный ордер",
  "order.creation-date": "Дата создания",
  "order.edit-completed": "Ордер успешно изменён!",
  "order.edit-fee-alert": "Учтите, что изменение в лимитном ордере приведёт к комиссии сети в размере <n />",
  "order.edit-order": "Редактировать ордер",
  "order.expiry": "Срок Действия",
  "order.limit-buy-tooltip": "Купить когда {{target}} равняется или ниже {{currency}}{{price}}",
  "order.limit-sell-tooltip": "Продать когда {{target}} ниже {{currency}}{{stopLoss}} или выше {{currency}}{{takeProfit}}",
  "order.status.active": "Активный",
  "order.status.failed": "Неудачный",
  "order.table.avg-exec": "Ср. Исп.",
  "order.table.order-amt": "Сумма",
  "order.table.side": "Тип",
  "order.trigger-condition": "Условия Срабатывания",
  "orders.cancel-all": "Отменить все",
  "orders.empty": "Ничего не ждёт",
  "orders.page.active-tokens-orders": "Активные ордера токенов",
  "orders.page.description": "Управлять лимитными и продвинутыми ордерами",
  "orders.trigger.market-cap": "Кап.",
  "orders.trigger.price": "Цена",
  "orders.page.title": "Ордера",
  "otp.modal.error": "Неверный OTP код",
  "otp.modal.subtitle": "Для Вашей безопасности, введите OTP код из приложения аутентификации",
  "otp.modal.title": "Подтвердите, что это Вы",
  "pair-activity.boost-purchased": "<0>{{count}} бустов</0> куплено",
  "pair-activity.premium-purchased": "куплен",
  "pair.cashback-mode.tooltip": "Комиссии создателя возвращаются трейдерам, а не создателям",
  "pair.fees": "Комиссии",
  "pair.fees.bundle-fees": "Комиссия за бандл",
  "pair.fees.gas-fees": "Комиссия за газ",
  "pair.fees.pool-fee": "Комиссия пула",
  "pair.fees.priority-fees": "Приоритетные комиссии",
  "pair.filter.pair-age": "Возраст пары (мин)",
  "pair.filter.socials": "Соц. сети",
  "pair.migrated": "Мигрирован",
  "pair.pair-address": "Адрес пары",
  "pair.pair-not-found": "Пара не найдена",
  "pair.pair-not-found.description": "Пара, которую Вы ищете недоступна или ссылка неправильная",
  "pair.token-migrated-tooltip": "Токен мигрировал {{timestamp}}",
  "pair.tokenized-agent.tooltip": "Токенизированный агент",
  "password": "Пароль",
  "platform.all_platforms": "Все платформы",
  "platform.deluge_apps": "Приложения kol.trade",
  "policies.affiliate-program-terms": "Условия партнерской программы",
  "policies.anti-money-laundering-policy": "Политика противодействия отмыванию денег (AML)",
  "policies.boosting-terms": "Условия бустинга",
  "policies.disclaimer-terms": "Отказ от ответственности",
  "policies.legal-entity-access-terms": "Запросы правоохранительных органов",
  "policies.live-streaming-terms": "Условия live streaming",
  "policies.privacy-policy": "Политика конфиденциальности",
  "policies.terms-of-service": "Условия обслуживания",
  "policies.token-creation-and-promotion-terms": "Условия создания и продвижения токенов",
  "pool": "Пара",
  "pool.currency-ca": "КА Токена",
  "pool.currency-price": "Цена Токена",
  "pool.liquidity": "Ликвидность",
  "pool.liquidity-char": "Л",
  "pool.liquidity-pool": "Пул Ликвидности",
  "pool.mcap": "КАП.",
  "pool.mcap_char": "К",
  "pool.open-in-explorer": "Открыть в {{provider}}",
  "pool.pair-ca": "КА Пары",
  "pool.select-pool": "Выберите Пару",
  "portfolio.active-positions.title": "Активные позиции",
  "portfolio.hidden-positions": "Скрытые позиции",
  "portfolio.page.title": "Анализатор Портфолио",
  "portfolio.pnl-chart.calendar-next-month": "Следующий месяц",
  "portfolio.pnl-chart.calendar-prev-month": "Предыдущий месяц",
  "portfolio.pnl-chart.chart-view": "График",
  "portfolio.pnl-chart.error-description": "После того как Вы откроете первую позицию",
  "portfolio.pnl-chart.error-description.another-user": "Торговые статистики этого пользователя будут показаны здесь после того, как он откроет свою первую позицию",
  "portfolio.pnl-chart.error-title": "Ваши торговые статистики будут показаны здесь",
  "portfolio.pnl-chart.error-title.another-user": "Торговые статистики этого пользователя будут показаны здесь",
  "portfolio.pnl-chart.title": "Реализованный PnL",
  "portfolio.pnl-chart.view-calendar": "Календарный вид",
  "portfolio.trade-history": "История трейдов",
  "portfolio.trading-distribution.loss": "Менее 0%",
  "portfolio.trading-distribution.profit-over-200": "Более 200%",
  "portfolio.trading-distribution.profit-under-200": "0 - 200%",
  "portfolio.trading-distribution.title": "Распределение",
  "position_few": "Позиции",
  "position_many": "Позиции",
  "position_one": "Позиция",
  "position_other": "Позиции",
  "position_zero": "Позиций",
  "position.all-positions": "Все позиции",
  "position.bought": "Куплено",
  "position.close-position": "Закрыть позицию",
  "position.close-position-confirm-description": "Закрывая эту позицию, Вы продадите все токены ассоциированные с ним по рынку.",
  "position.close-position-confirm-title": "Вы уверены, что хотите закрыть эту позицию?",
  "position.closed": "закрыта",
  "position.entry-price": "Цена входа",
  "position.hide-position.tooltip": "Скрыть позицию",
  "position.invest": "Инвестиция",
  "position.invest-short": "Инв.",
  "position.position-closed-all-message": "Все позиции {{ticker}} были закрыты",
  "position.position-details": "Детали позиции",
  "position.remaining": "Осталось",
  "position.remaining-short": "Ост.",
  "position.sold": "Продано",
  "position.sold-short": "Прод.",
  "position.table.visibility": "Видимость",
  "position.target-price": "Цель цены",
  "position.unhide-position.tooltip": "Показывать позицию",
  "position.wallet-position-modal.title": "{{ticker}} позиции по кошелькам",
  "premium.archived-label": "Архив",
  "premium.archived-list.archive": "Архив",
  "premium.archived-list.current": "Текущий",
  "premium.archived-list.date": "Дата",
  "premium.archived-list.owner": "Владелец",
  "premium.archived-list.title": "Архивный список",
  "premium.boosters": "Бусты",
  "premium.button.boost": "Буст",
  "premium.button.buy-again": "Купить ещё раз",
  "premium.button.buy-boosters": "Купить Бусты",
  "premium.button.buy-subscription": "Купить Премиум",
  "premium.button.pay-amount": "Оплатить",
  "premium.button.renew": "Продлить",
  "premium.button.renew-premium": "Продлить Премиум",
  "premium.carousel.empty.sub-title": "Ваши премиум токены будут отображены здесь",
  "premium.carousel.empty.title": "У Вас нет премиум токенов!",
  "premium.carousel.title": "Другие токены с премиумом",
  "premium.check.alert.active": "У этого токена уже есть подписка",
  "premium.check.alert.failed": "Токен не прошёл проверки безопасности",
  "premium.check.alert.passed": "Токен прошёл проверки безопасности",
  "premium.check.currency.supply": "Циркуляция: {{supply}} {{ticker}}",
  "premium.check.message.unknown-error": "Не удалось проверить токен",
  "premium.check.note.active": "Вы можете купить бусты для этого токена!",
  "premium.check.note.failed": "Проверить Другой Токен",
  "premium.check.note.passed": "Вы можете купить <0>Premium</0> подписку!",
  "premium.check.result": "Результат проверки токена",
  "premium.currency.emoji": "Эмодзи для трендов",
  "premium.currency.sub-title": "которые вы добавили к токенам",
  "premium.currency.title": "Ваши Токены",
  "premium.extend.title": "Продлить <0>Premium</0>",
  "premium.feed": "Премиум-лента",
  "premium.feed.buy-premium": "Купить Premium",
  "premium.feed.purchased-item": "Покупка",
  "premium.form.invalid-url-telegram": "Неверная ссылка на Telegram",
  "premium.form.invalid-url-website": "Неверная ссылка на сайт",
  "premium.form.invalid-url-x": "Неверная ссылка на X",
  "premium.image-upload.loading-description": "Ваше изображение загружается",
  "premium.image-upload.loading-title": "Подождите минуту...",
  "premium.image-upload.size": "размер изображения должен быть {{size}}",
  "premium.info.button.check-token": "Проверить Токен",
  "premium.info.sub-title": "Токены проходящие проверки безопасности имеют возможность приобрести Premium подписку и затем Splash Point бусты для увеличения числа очков Splash Point в трендах.",
  "premium.info.text.cost": "Подписка выдаётся при покупке {{boosts}} бустов и действует 30 дней, если у токена её пока нет",
  "premium.info.text.how-to-buy": "в <0>приложении</0> с помощью специальной ссылки",
  "premium.info.text.requirements": "Токен должен пройти проверки безопасности",
  "premium.info.text.validity": "30 дней. С возможностью продлить ещё на 30 дней при покупке {{extendBoosts}} бустов, если срок действия подписки составляет меньше 7 дней.",
  "premium.info.text.what-it-gives": "Возможность купить Splash Point бусты при прохождении проверок безопасности <0/> Изменение логотипа в приложении <0/> Добавление баннера на страницу токена <0 /> Добавление ссылок на соц. сети на странице токена",
  "premium.info.title.cost": "Цена",
  "premium.info.title.how-to-buy": "Как купить",
  "premium.info.title.requirements": "Условия",
  "premium.info.title.validity": "Срок действия",
  "premium.info.title.what-it-gives": "Что это даёт",
  "premium.not-eligible-snackbar.description": "Премиум для этого токена уже куплен другим пользователем. Вы не можете изменить данные этого токена.",
  "premium.not-eligible-snackbar.title": "Невозможно изменить данные",
  "premium.owned-by": "Владелец",
  "premium.pay.boosters.note": "Splash Point Бусты работают 24 часа и затем сгорают. Вы можете купить любое количество бустов для токена",
  "premium.pay.boosters.success": "Вы можете купить <0>Бусты</0> для любого токена с премиум подпиской, который проходит проверки безопасности",
  "premium.pay.boosters.title": "Купить Splash Point <0>Бусты</0>",
  "premium.pay.check-tx": "Просмотреть транзакцию",
  "premium.pay.error-ballance": "Недостаточный Баланс",
  "premium.pay.extend-error": "Не удалось продлить премиум",
  "premium.pay.no-wallet": "Выберите кошелёк",
  "premium.pay.not-enough-boosters-for-premium": "Минимум {{boosters}} бустов",
  "premium.pay.portal-link.info-text": "Установите ссылку на Telegram группу или портал в группу.",
  "premium.pay.portal-link.invalid": "Неверная ссылка на портал",
  "premium.pay.portal-link.title": "Telegram Ссылка",
  "premium.pay.safety-check.check-btn": "Проверить безопасность токена",
  "premium.pay.safety-check.description": "Чтобы купить бусты, <0>Premium</0> должен быть подключён к токену.",
  "premium.pay.subscription.link": "Введите ссылку на Telegram группу",
  "premium.pay.subscription.link-placeholder": "https://t.me/portallink",
  "premium.pay.subscription.note": "Премиум подписка выдаётся при покупке {{boosts}} бустов и действует 30 дней, если у токена её пока нет. Также подписка продляется при покупке {{extendBoosts}} бустов, если её срок истекает менее чем через 7 дней",
  "premium.pay.subscription.success": "Вы можете <0>купить Premium</0> для любого токена который проходит проверки безопасности",
  "premium.pay.subscription.title": "Купить <0>Premium</0>",
  "premium.pay.wallets.title": "Выберите способ оплаты",
  "premium.product.booster-text": "Цена буста {{price}} SOL и он работает 24 часа",
  "premium.product.booster-title": "Splash Point <0>Буст</0>",
  "premium.product.premium-text": "Подписка выдаётся при покупке {{boosts}} бустов и действует 30 дней, если у токена её пока нет",
  "premium.product.premium-title": "<0>Премиум</0> Подписка",
  "premium.purchase.invoice": "Инвойс",
  "premium.purchase.status.failed": "Ошибка",
  "premium.purchase.status.processing": "Обработка",
  "premium.purchase.status.success": "Успешно",
  "premium.purchased.date-due": "<0>Premium</0> до {{date}}",
  "premium.purchased.date-ended": "закончился {{date}}",
  "premium.purchased.empty-description": "И продвигайте токены с помощью бустов",
  "premium.purchased.empty-title": "Включите Premium для первого токена",
  "premium.purchased.sub-title": "которые вы добавили к токенам",
  "premium.purchased.tab.active": "Текущие Премиумы",
  "premium.purchased.tab.inactive": "Истекшие Премиумы",
  "premium.purchased.tab.purchase-history": "История покупок",
  "premium.purchased.title": "Ваши Токены",
  "premium.purchased.title-long": "Ваша Премиум Подписка",
  "premium.purchased.until": "до {{date}}",
  "premium.search.error.currency-not-found": "Токен не найден",
  "premium.search.subtitle": "Уже есть Premium?",
  "premium.search.subtitle-check-token": "Проверьте токен на безопасность перед покупкой премиума",
  "premium.search.title": "Введите адрес токена",
  "premium.slider.slide-banner": "Возможность изменить эмодзи и баннер в трендах",
  "premium.slider.slide-color": "Выделение символа токена цветом на основе SP ранга",
  "premium.slider.slide-logo": "Возможность изменить лого токена в приложении",
  "premium.slider.slide-raid": "<0>До 3 одновременных рейдов вместо 1</0><br />Без подписки только 1",
  "premium.slider.slide-splash": "Возможность покупки Splash Point бустов",
  "premium.slider.title": "Что <0>Premium</0> даёт токену?",
  "premium.splash-points": "Очки Splash Point",
  "premium.title": "Premium",
  "premium.update-emoji.change-image": "Изменить изображение",
  "premium.update-emoji.choose-image": "Выбрать изображение",
  "premium.update-emoji.preview": "Предпросмотр",
  "premium.update-emoji.title": "Настройте Ваш эмодзи для трендов",
  "premium.update-links.updated": "Социальные ссылки были успешно обновлены",
  "premium.update-logo.error.retry": "Попробовать другое изображение",
  "premium.update-logo.error.support": "Написать поддержке",
  "premium.update-logo.image-safety-heck-failed": "Изображение не прошло верификацию.",
  "premium.update-logo.preview": "Пример использования",
  "premium.update-logo.processing": "Подождите минуту... <0>Ваше изображение загружается</0>",
  "premium.update-logo.success": "Успех! <0>Ваш логотип в процессе</0>",
  "premium.update-logo.title": "Выберите изображение",
  "price": "Цена",
  "profile.all_past_purchases": "Все прошлые покупки",
  "profile.analysis.analysis": "Анализ",
  "profile.analysis.avg-cost": "Сред. Стоимость",
  "profile.analysis.avg-duration": "Сред. Продолжительность",
  "profile.analysis.avg-realized-profits": "Сред. Прибыль",
  "profile.analysis.avg-sold": "Сред. Продажа",
  "profile.analysis.fees": "Комиссии",
  "profile.analysis.fees-tooltip": "Общая комиссия за транзакции",
  "profile.analysis.renamed": "Переименованные",
  "profile.analysis.tracked": "Отслеживаемые",
  "profile.analysis.txs": "Транз.",
  "profile.analysis.volume-tooltip": "Общий объём тредов",
  "profile.avg_buy_mc_distribution": "Распределение Среднeй Покупки Кап.",
  "profile.avg_buy_mc_distribution.above_500k": "> $500k",
  "profile.avg_buy_mc_distribution.below_100k": "$0 - $100k",
  "profile.avg_buy_mc_distribution.from_100k_to_500k": "$100k - $500k",
  "profile.best_deal": "Лучшая сделка",
  "profile.best_deal_title": "Лучшая Сделка",
  "profile.best_deal.close_price": "Цена закрытия",
  "profile.best_deal.download_error": "Ошибка скачивания",
  "profile.best_deal.download_success": "Файл успешно скачан",
  "profile.best_deal.entry_price": "Цена входа",
  "profile.best_deal.share_result": "Поделиться",
  "profile.best_deal.title": "Ваша лучшая сделка",
  "profile.buy_d_premium": "Купить Premium",
  "profile.connections.followers-other.empty-description": "Данный пользователь не имеет подписчиков, трейды появятся здесь после того как пользователь начнёт торговать.",
  "profile.connections.followers-other.empty-title": "У профиля нет подписчиков",
  "profile.connections.followers.empty-description": "У вас пока нет подписчиков — начните активно торговать и привлекать внимание к своему профилю.",
  "profile.connections.followers.empty-title": "У вас нет подписчиков",
  "profile.connections.followings.empty-description": "Находите интересных пользователей, следите за их трейдами и транзакциями.",
  "profile.connections.followings.empty-title": "Находите новых пользователей и следите за их сделками",
  "profile.distribute-drawer.token-distribution": "Распределение токенов",
  "profile.distribution": "Распределение",
  "profile.edit_profile": "Редактировать профиль",
  "profile.edit.change-avatar.only-hyped-tooltip": "Для установки аватара нужно иметь статус Hyped",
  "profile.leaderboard": "Список лидеров",
  "profile.phishing-check.danger": "опасный",
  "profile.phishing-check.normal": "чистый",
  "profile.phishing-check.warning": "предупреждение",
  "profile.positions-active": "Активные позиции",
  "profile.profile_avatar_updated": "Аватар профиля обновлён",
  "profile.profile_info_updated": "Информация профиля обновлена",
  "profile.profit": "Прибыли",
  "profile.social.past-handles": "Прошлые ники",
  "profile.social.twitter-stats.favoritesCount": "Количество лайков",
  "profile.social.twitter-stats.followersCount": "Количество подписчиков",
  "profile.social.twitter-stats.followingCount": "Количество подписок",
  "profile.social.twitter-stats.mediaCount": "Количество медиа-публикаций",
  "profile.statistics": "Статистика",
  "profile.statistics.buy_premium": "<0>Купить</0> <1>Premium</1> для токена",
  "profile.statistics.tab-distribution": "Распределение",
  "profile.statistics.tab-phishing": "Фишинг",
  "profile.statistics.tab-profit": "Прибыли",
  "profile.statistics.tabs.deployed-tokens": "Запущенные токены",
  "profile.statistics.tabs.holdings": "Хранение",
  "profile.statistics.tabs.trades": "Трейды",
  "profile.statistics.trading_leaderboard": "Таблица Лидеров Торговли",
  "profile.trading_summary": "Торговая Сводка",
  "profile.transaction_history": "История транзакций",
  "profile.user-trading-analytics.blacklist": "Чёрный список",
  "profile.user-trading-analytics.block-title": "Проверка на фишинг",
  "profile.user-trading-analytics.didnt-buy": "Не купил",
  "profile.user-trading-analytics.fast-flip": "Покупка/продажа за 5 с",
  "profile.user-trading-analytics.sold-more-than-bought": "Продано > куплено",
  "profile.welcome.buy_premium": "<0>Купить Premium</0> для токена, чтобы получить",
  "profile.welcome.no_active_premium_tokens": "У вас нет активных Premium токенов",
  "profile.welcome.past_purchases": "Ваши прошлые покупки",
  "protocol": "Протокол",
  "protocol_many": "Протоколы",
  "provider": "Провайдер",
  "referral": "Реферал",
  "referral.add-invite-code": "Добавить инвайт код",
  "referral.add-invite-code-description": "Вы получите код от другого пользователя:",
  "referral.add-referral-code": "Добавить реферальный код",
  "referral.bring_out": "Вывести",
  "referral.change-invite-code": "Изменить инвайт код",
  "referral.change-referral-code": "Изменить реферальный код",
  "referral.change-referral-note": "Вы платите только комиссию за газ для переименования",
  "referral.code_copied_message": "Реферальный код скопирован!",
  "referral.code-info.current-code-label": "текущий код:",
  "referral.create_referral_code": "Создать реферальный код",
  "referral.create-price-title": "Создание реферального кода стоит",
  "referral.create-subtitle": "Вы можете получить <0>много бонусов от других пользователей</0> через ваш <0>реферальный код</0>:",
  "referral.create-title": "Пригласите первого реферала!",
  "referral.current-code-user-label": "Текущий код и пользователь:",
  "referral.earnings": "Заработок с реф.",
  "referral.enter_new_referral_code": "Введите новый реферальный код",
  "referral.enter_referral_code": "Введите реферальный код",
  "referral.enter_unique_code": "Введите уникальный код",
  "referral.invite": "Пригласить",
  "referral.invite_referral": "Пригласить рефералов",
  "referral.invite-code": "Инвайт код",
  "referral.invite-code-form.note": "Этот код действителен только на <0>{{network}}</0> блокчейне",
  "referral.invite-code.current-code": "текущий код",
  "referral.invite-code.empty-description": "У вас пока нет инвайт кода от другого пользователя",
  "referral.invite-referral-description": "Получайте дополнительные бонусы от транзакций ваших рефералов.",
  "referral.leaderboard": "Таблица Лидеров",
  "referral.network-referral-code": "{{network}} Реф. Код",
  "referral.new_referral_code_description": "Введите реферальный код, чтобы активировать его",
  "referral.new_referral_code_has_been_successfully_created": "Новый реферальный код был успешно создан",
  "referral.new-code-user-label": "Новый код и пользователь:",
  "referral.no-link-placeholder": "Чтобы получить реферальную ссылку, Вам нужно связаться с поддержкой",
  "referral.point1": "Получайте <0>0.05% бонуса</0> с каждого свапа вашего реферала",
  "referral.point2": "<0>Скидки</0> на ваши собственные транзакции <0>до 80%</0>",
  "referral.point3": "Персональные <0>бонусы</0> каждый торговый период",
  "referral.points-info.label": "Ваши бонусы от рефералов:",
  "referral.referral_code": "Реферальный код",
  "referral.referral_code_has_been_successfully_changed": "Реферальный код успешно изменен",
  "referral.referral_code_has_been_successfully_set": "Реферальный код был успешно установлен",
  "referral.referral_users": "Рефералы",
  "referral.referral-code-form.note": "Вы создаёте реферальный код в блокчейне <0>{{network}}</0>",
  "referral.share-text": "Use my referral link to join me on kol.trade — the crypto trading bot you can trust!",
  "referral.try-another-code": "Попробуйте другой код",
  "referral.update_referral_code": "Обновить реферальный код",
  "referral.users-referred": "пользователей приглашено",
  "referral.view-referral-subtitle": "Теперь вы можете поделиться им и получать все бонусы платформы",
  "referral.withdraw.bring_out": "Вывести",
  "referral.withdraw.processing.title": "Транзакция в процессе",
  "referral.withdraw.select_wallet": "Выберите кошелёк чтобы вывести",
  "referral.withdraw.send-to": "Отправить на",
  "referral.withdraw.transaction-in-process": "Транзакция в процессе",
  "referral.withdraw.transaction-in-process-message": "Транзакция не может быть выполнена из-за нагрузки сети или недостаточной ликвидности.",
  "referral.withdraw.your-referral-balance": "Ваш реферальный баланс",
  "referral.your_referrals": "Ваши Рефералы",
  "referral.your-referral-code": "Ваш реферальный код",
  "report.report-telegram-group-description": "Пожалуйста, предоставьте причину и любую дополнительную информацию для репорта группы",
  "report.report-telegram-group-success": "Жалоба на Telegram группу была отправлена",
  "scan.camera-permission-denied": "Отсутствует разрешение на использование камеры",
  "scan.camera-permission-denied-description": "Пожалуйста, включите разрешение на использование камеры в настройках",
  "scan.invalid-address": "Неверный адрес кошелька",
  "scan.scan-qr-code": "Сканировать QR Код",
  "scan.scan-qr-code-description": "Поместите QR код в рамку сканирования",
  "scan.unable-to-scan-qr-code": "Не получилось отсканировать QR код",
  "search.no-recent-searches": "Нет недавних поисков",
  "search.recents": "Недавние",
  "search.search-by-firstname-lastname-username": "Ищите по имени, фамилии или никнейму",
  "seed-phrase": "Секретная Фраза",
  "session.delete-confirmation": "Вы точно хотите удалить эту сессию?",
  "session.delete-session": "Удалить сессию",
  "session.delete-session-error": "Не удалось удалить сессию",
  "session.delete-session-success": "Сессия была удалена",
  "sessions": "Сессии",
  "sessions.browser": "браузер",
  "sessions.ip_address": "IP адрес",
  "sessions.last_session": "последняя сессия",
  "sessions.os": "ОС",
  "sessions.this_device": "Это устройство",
  "settings": "Настройки",
  "settings.about-the-app": "О приложении",
  "settings.account-and-privacy": "Аккаунт и конфиденциальность",
  "settings.active_sessions": "Активные сессии",
  "settings.app-settings": "Настройки приложения",
  "settings.app-settings.interface-size": "Масштаб интерфейса",
  "settings.app-settings.is-flash-distinct-enabled": "Показывать анимации вспышек отличий",
  "settings.app-settings.show-pair-activity-notifications": "Показывать уведомления о росте",
  "settings.app-settings.show-pair-audit-alert": "Показывать предупреждение с аудитом пары",
  "settings.app-settings.show-shortcuts-hints": "Показывать подсказки горячих клавиш",
  "settings.app-settings.show-social-network-safety-link-alert": "Показывать предупреждение при переходе по социальным ссылкам",
  "settings.app-settings.show-system-notifications": "Показывать системные уведомления",
  "settings.app-settings.theme": "Тема приложения",
  "settings.app-settings.use-sound-notifications": "Использовать звуковые уведомления",
  "settings.auto-scale-acknowledgment.description": "Приложение автоматически отмасштабировано под ваш экран для лучшей читаемости и удобства использования.",
  "settings.auto-scale-acknowledgment.description-2": "Вы можете изменить это поведение в настройках в любое время.",
  "settings.auto-scale-acknowledgment.title": "Автомасштабирование включено",
  "settings.google.authorization": "Google Авторизация",
  "settings.google.connect-error": "Не удалось подключить Google аккаунт",
  "settings.google.disconnect-description": "Вы больше не сможете входить с помощью Google аккаунта",
  "settings.google.disconnect-title": "Отвязать Google",
  "settings.google.success": "Google аккаунт был успешно привязан",
  "settings.google.unassign-success": "Google аккаунт был отвязан",
  "settings.incognito.label": "Режим инкогнито",
  "settings.language.auto": "Авто",
  "settings.language.auto-description": "Основано на настройках системы",
  "settings.language.change-successful": "Язык успешно изменен",
  "settings.local-password.item": "Локальный пароль",
  "settings.local-password.title": "Изменить Локальный Пароль",
  "settings.local-password.toast-changed": "Локальный пароль был изменён",
  "settings.password.item": "Пароль аккаунта",
  "settings.password.title": "Изменить Пароль",
  "settings.password.title-current": "Введите текущий пароль",
  "settings.password.title-new": "Введите новый пароль",
  "settings.password.title-new-repeat": "Повторите новый пароль",
  "settings.password.toast-changed": "Пароль был изменён",
  "settings.password.toast-repeat-error": "Введённые пароли не совпадают",
  "settings.password.toast-wrong": "Введённый текущий пароль неправильный",
  "settings.security": "Безопасность",
  "settings.security.otp-quick-login": "Всегда запрашивать OTP",
  "settings.security.otp-quick-login.description": "Всегда запрашивать одноразовый код при входе.<br />Если выключено — код будет требоваться при обнаружении попытки взлома.",
  "settings.trading-mode": "Режим торговли",
  "settings.trading-mode.advanced": "Продвинутый",
  "settings.trading-mode.advanced.description": "Торговля со своих кошельков. Ключи у вас, каждую сделку подписываете сами и сами платите комиссию сети.",
  "settings.trading-mode.basic": "Базовый",
  "settings.trading-mode.basic.description": "Торговля с одного баланса, который вы пополняете. Сделки подписываются за вас — кошелёк настраивать не нужно и подтверждать нечего.",
  "settings.trading-mode.note": "Переключение не двигает деньги. Кошельки сохраняют свои балансы, базовый баланс — свой; выбор лишь определяет, откуда вы торгуете. Настройка хранится на аккаунте, поэтому бот следует ей тоже.",
  "settings.telegram.authorization": "Telegram Авторизация",
  "settings.telegram.connect-error": "Не удалось привязать Telegram аккаунт",
  "settings.telegram.disconnect-description": "Вы больше не сможете входить с помощью Telegram аккаунта",
  "settings.telegram.disconnect-title": "Отвязать Telegram",
  "settings.telegram.success": "Telegram аккаунт был успешно привязан",
  "settings.telegram.unassign-success": "Telegram аккаунт был отвязан",
  "settings.twitter.authorization": "X(Twitter) Авторизация",
  "settings.twitter.connect-error": "Не удалось привязать X(Twitter) аккаунт",
  "settings.twitter.disconnect-description": "Ваш аккаунт X (Twitter) будет отвязан от аккаунта приложения.",
  "settings.twitter.disconnect-title": "Отвязать X(Twitter)",
  "settings.twitter.label": "X(Twitter) Аккаунт",
  "settings.twitter.success": "X(Twitter) аккаунт был успешно привязан",
  "settings.twitter.unassign-success": "X(Twitter) аккаунт был отвязан",
  "shortcuts": "Горячие клавиши",
  "shortcuts.copy-trade-page-link": "Скопировать ссылку на страницу трейда в буфер обмена",
  "shortcuts.open-clipboard-pair": "Открыть пару из буфера обмена",
  "shortcuts.open-profile": "Открыть профиль",
  "shortcuts.open-search-modal": "Открыть поисковое модальное окно",
  "shortcuts.open-settings-modal": "Открыть окно настроек",
  "splash-points.description": "Каждый токен зарабатывает Splash-Points на основе 3 факторов:",
  "splash-points.description-factors": "объём, свопы и рейды",
  "splash-points.doc-title": "Информация о Splash Points",
  "splash-points.error": "Что-то пошло не так. Пожалуйста, попробуйте позже.",
  "splash-points.loading": "Загрузка информации о токене",
  "splash-points.logarithm-disclaimer": "Логарифмы помогают сбалансировать огромные значения, в то время как возведение в квадрат усиливает хорошо скоординированные рейды",
  "splash-points.makers": "Уникальные кошельки",
  "splash-points.makers-description": "Уникальные кошельки, торгующие токеном.",
  "splash-points.makers-formula": "points = log(makers x 20) x 2.5",
  "splash-points.raids": "Рейды",
  "splash-points.raids-description": "Сильная социальная активность (лайки, ретвиты, ответы, закладки) даёт большой буст! raidCoefficient - это небольшой множитель для масштабирования влияния рейда (например, 0.002).",
  "splash-points.raids-formula": "очки = (очки мощности / (1.6 × рейды + 1))² × (1 + 0.01 × рейды)",
  "splash-points.swaps": "Свопы",
  "splash-points.swaps-description": "Больше активности свопов (покупки и продажи) означает более высокие баллы — частая торговля повышает видимость.",
  "splash-points.swaps-formula": "очки = log(свопы x 20) x 2.5",
  "splash-points.title": "Как Рассчитываются Splash Points?",
  "splash-points.volume": "Объём",
  "splash-points.volume-description": "Больший торговый объём приносит больше очков, но с убывающей отдачей благодаря логарифму.",
  "splash-points.volume-formula": "очки = log(объём usd x 10) x 10",
  "summary.your_summary": "Ваша Сводка",
  "support": "Поддержка",
  "support.chat-intro-you-started": "Вы начали чат",
  "support.close-ticket": "Закрыть тикет",
  "support.contact-support": "Связаться с поддержкой",
  "support.create-new-ticket": "Создать новый тикет",
  "support.empty-messages": "Пока нет сообщений..",
  "support.form.email-optional-label": "Email (необязательно)",
  "support.form.email-placeholder": "example@example.com",
  "support.form.email-replies-checkbox": "Хочу получать ответы на email",
  "support.form.name-label": "Имя",
  "support.form.name-placeholder": "Бен Чжоу",
  "support.form.problem-description-label": "Описание проблемы",
  "support.form.problem-description-placeholder": "Опишите проблему подробно...",
  "support.form.problem-title-label": "Заголовок проблемы",
  "support.form.problem-title-placeholder": "Кратко о проблеме...",
  "support.form.submit-create-ticket": "Создать тикет",
  "support.heading-brand": "Support",
  "support.new-ticket": "Новый тикет",
  "support.past-tickets": "Прошлые тикеты",
  "support.reopen-ticket": "Переоткрыть тикет",
  "support.ticket-created-label": "создан",
  "support.ticket-status-updated.active": "Тикет {{subject}} переоткрыт",
  "support.ticket-status-updated.closed": "Тикет {{subject}} закрыт",
  "support.tickets-admin.active-tickets": "В работе",
  "support.tickets-admin.closed-tickets": "Закрытые",
  "support.tickets-admin.unread-tickets": "Новые тикеты",
  "support.typing": "Support печатает",
  "support.welcome-brand": "Support!",
  "support.welcome-message": "Наша поддержка доступна 24/7 и готова помочь с любыми вопросами.",
  "support.welcome-title-to": "в ",
  "support.welcome-title-welcome": "Добро пожаловать",
  "swap": "Трейд",
  "swap_few": "Трейда",
  "swap_many": "Трейдов",
  "swap_one": "Трейд",
  "swap_other": "Трейды",
  "swap_zero": "Трейдов",
  "swap.base-label": "Вы отправляете",
  "swap.completed": "Обмен Завершён!",
  "swap.confirm_swap": "Подтвердить трейд",
  "swap.error": "Обмен не удался",
  "swap.load-pools": "Загрузить пары",
  "swap.loading-pools": "Загрузка пар",
  "swap.no-pool-available": "Нет доступных пар",
  "swap.no-pool-available.description": "К сожалению, для этой пары нет доступных пулов. Попробуйте выбрать другую пару.",
  "swap.pool-loading-error": "Не удалось загрузить пары",
  "swap.processing": "Обмен в Процессе",
  "swap.quote-label": "Вы получаете",
  "swap.review_swap": "Обзор трейда",
  "swap.seconds-short": "сек",
  "swap.select-pool": "Выберите пару",
  "swap.swap-screen.title": "Обмен Активов",
  "table.active": "Активный",
  "table.audit.cr": "Право Заморозки Выключено",
  "table.audit.cv": "Право Чеканки Токенов Выключено",
  "table.audit.nhp": "{{percentage}}% ликвидного пула сожжено.\nЗелёная галочка если больше 50%",
  "table.audit.t10": "{{percentage}}% во владении у топ 10 холдеров. Зелёная галочка если у топ 10 холдеров меньше 15%",
  "table.bought": "Куплено",
  "table.filter.at-least-1-social": "С минимум 1 соц. сетью",
  "table.filter.keywords-placeholder": "Ключевое слово 1, Ключевое слово 2 ... (макс. 5)",
  "table.filter.lp-burned": "ЛП сожжён",
  "table.filter.mint-auth-disabled": "Право Чеканки Выключено",
  "table.filter.top-10-holders": "Топ 10 Холдеров",
  "table.holders": "Холдеры",
  "table.maker": "Мейкер",
  "table.market_cap": "Капитализация",
  "table.message.login_to_account": "войдите в аккаунт",
  "table.message.no_data": "Данные недоступны",
  "table.network_balance": "{{network}} Бал.",
  "table.pnl": "Pnl",
  "table.quick_buy": "Быстрая Покупка",
  "table.rank": "Ранг",
  "table.remaining": "Осталось",
  "table.safety_checks": "CV/CR/NHP/T10",
  "table.sold": "Продано",
  "table.swaps": "Трейды",
  "theme.button.title": "Тема",
  "theme.custom.acid": "Кислотный",
  "theme.custom.amber": "Янтарный",
  "theme.custom.appearance": "Профиль",
  "theme.custom.appearance.dark": "Тёмный",
  "theme.custom.appearance.light": "Светлый",
  "theme.custom.appearanceColor": "Базовый",
  "theme.custom.background": "Фон",
  "theme.custom.baseTheme": "Базовая тема",
  "theme.custom.blue": "Синий",
  "theme.custom.boostButton": "Кнопка буста",
  "theme.custom.boostGlow": "Свечение буста",
  "theme.custom.boostGradientFrom": "Градиент буста от",
  "theme.custom.boostGradientTo": "Градиент буста до",
  "theme.custom.boostIcon": "Иконка буста",
  "theme.custom.bronze": "Бронзовый",
  "theme.custom.candleGreen": "Растущая свеча",
  "theme.custom.candleGreenBorder": "Рамка растущей свечи",
  "theme.custom.candleGreenWick": "Фитиль растущей свечи",
  "theme.custom.candleRed": "Падающая свеча",
  "theme.custom.candleRedBorder": "Рамка падающей свечи",
  "theme.custom.candleRedWick": "Фитиль падающей свечи",
  "theme.custom.cyan": "Бирюзовый",
  "theme.custom.down": "Падение",
  "theme.custom.downAccent": "Акцент падения",
  "theme.custom.error": "Ошибка",
  "theme.custom.errorAccent": "Акцент ошибки",
  "theme.custom.golden": "Золотой",
  "theme.custom.gray": "Серый",
  "theme.custom.green": "Зелёный",
  "theme.custom.name": "Своя",
  "theme.custom.neutral": "Нейтральный",
  "theme.custom.neutralAccent": "Акцент нейтрального",
  "theme.custom.orange": "Оранжевый",
  "theme.custom.pink": "Розовый",
  "theme.custom.primary": "Первичный",
  "theme.custom.purple": "Фиолетовый",
  "theme.custom.red": "Красный",
  "theme.custom.silver": "Серебряный",
  "theme.custom.subscriptionButton": "Кнопка подписки",
  "theme.custom.subscriptionGlow": "Свечение подписки",
  "theme.custom.subscriptionGradientFrom": "Градиент подписки от",
  "theme.custom.subscriptionGradientTo": "Градиент подписки до",
  "theme.custom.subscriptionIcon": "Иконка подписки",
  "theme.custom.success": "Успех",
  "theme.custom.successAccent": "Акцент успеха",
  "theme.custom.tab.base": "Базовые",
  "theme.custom.tab.candle": "Свечи",
  "theme.custom.tab.color": "Цвета",
  "theme.custom.tab.intents": "Интенты",
  "theme.custom.tab.premium": "Premium",
  "theme.custom.tab.trend": "Тренд",
  "theme.custom.text": "Текст",
  "theme.custom.up": "Рост",
  "theme.custom.upAccent": "Акцент роста",
  "theme.custom.warning": "Предупреждение",
  "theme.custom.warningAccent": "Акцент предупреждения",
  "theme.custom.yellow": "Жёлтый",
  "theme.deluge.description": "Тема kol.trade",
  "theme.deluge.name": "kol.trade",
  "theme.delugeLight.name": "kol.trade Light",
  "theme.dialog.title": "Выберите тему",
  "theme.monokai.name": "Monokai",
  "theme.photgone.name": "Photgone",
  "theme.test.description": "Тестовая тема",
  "theme.test.name": "Тестовая",
  "token": "Токен",
  "token_other": "Токены",
  "top-trader_few": "Топ Трейдера",
  "top-trader_many": "Топ Трейдеров",
  "top-trader_other": "Топ Трейдеры",
  "top-trader_zero": "Топ Трейдеров",
  "topbar.position.recent": "Недавние",
  "trade": "Трейд",
  "trade_few": "Трейда",
  "trade_many": "Трейдов",
  "trade_one": "Трейд",
  "trade_other": "Трейды",
  "trade_settings": "Настройки торговли",
  "trade_settings.anti_mev": "Анти MEV",
  "trade_settings.anti_mev_tooltip": "Защита от MEV позволяет Вам защитить транзакции использую Jito. Если это выключено, Ваша транзакция с большим шансом обработается, но могут быть риски MEV атак.",
  "trade_settings.anti_mev.info": "<p>MEV атакующие влияют на цену активов меняя порядок транзакций в сети, вставляя транзакции до и после Вашей транзакции, это приводит к финансовым потерям.</p><p>Защита от MEV позволяет Вам защитить транзакции использую Jito. Если это выключено, Ваша транзакция с большим шансом обработается, но могут быть риски MEV атак.</p>",
  "trade_settings.anti_mev.info-title": "Защита от MEV",
  "trade_settings.deadline": "Дедлайн",
  "trade_settings.deadline-min-message": "Минимальный дедлайн 1 минута",
  "trade_settings.flexible_gas_price": "Динамичная Цена Газа",
  "trade_settings.flexible_gas_price_tooltip": "Если включено, цена газа будет скорректирована автоматически основываясь на условиях в сети",
  "trade_settings.gas_price": "Цена Газа",
  "trade_settings.gas_price_tooltip": "Цена, которую Вы оплатите за газ",
  "trade_settings.jito_tip": "Jito Чаевые",
  "trade_settings.jito_tip_max_message": "Jito Чаевые должны быть меньше {{max}}",
  "trade_settings.jito_tip_tooltip": "Доп. комиссия, которую Вы готовы заплатить валидаторам Jito для повышения приоритета Вашей транзакции",
  "trade_settings.max_gas_price": "Макс. Цена Газа",
  "trade_settings.max_gas_price_tooltip": "Максимальная цена, которую Вы готовы заплатить за газ",
  "trade_settings.max_priority_fee_per_gas": "Макс. Приоритетной Комиссии За Газ",
  "trade_settings.max_priority_fee_per_gas_tooltip": "Максимальная цена, которую Вы готовы заплатить за приоритетную комиссию",
  "trade_settings.max-auto-priority": "Макс. авто комиссия",
  "trade_settings.preset-settings": "Настройки пресета",
  "trade_settings.priority_fee": "Приоритетная Комиссия",
  "trade_settings.priority_fee_max_message": "Приоритетная комиссия должна быть меньше {{max}}",
  "trade_settings.priority_fee_tooltip": "Цена, которую Вы готовы заплатить за приоритетную комиссию",
  "trade_settings.priority-and-tip-fee": "Приоритет и чаевые",
  "trade_settings.reset_settings": "Сброс настроек",
  "trade_settings.saved": "Настройки трейдинга были успешно сохранены.",
  "trade_settings.transaction-fee": "Комиссия Транзакции",
  "trade_zero": "Трейдов",
  "trade-settings.api-key": "API ключ",
  "trade-settings.custom-rpc": "Кастомная RPC",
  "trade-settings.custom-rpc-description": "Используйте свой RPC endpoint",
  "trade-settings.custom-rpc-placeholder": "https://your-rpc-endpoint.com",
  "trade-settings.custom-rpc-tooltip": "Отправка транзакций через ваш RPC-эндпоинт вместо Helius Sender.",
  "trade-settings.enter-slippage": "Введите проскальзывание",
  "trade-settings.execution-route": "Способ отправки",
  "trade-settings.execution-route-tooltip": "Выберите, как ваши транзакции отправляются в сеть. Только один способ может быть активен одновременно.",
  "trade-settings.helius-sender": "Helius Sender",
  "trade-settings.helius-sender-description": "Отправка через Helius global network",
  "trade-settings.helius-sender-tooltip": "Отправка транзакций с низкой задержкой через Helius staked connections",
  "trade-settings.location": "Локация",
  "trade-settings.quick-buy-amount": "Сумма быстрой покупки",
  "trade-settings.quick-buy-amount-updated-error-message": "Не удалось обновить сумму быстрой покупки",
  "trade-settings.quick-buy-amount-updated-message": "Быстрая покупка была установлена на {{amount}}",
  "trade-settings.quick-buy-amount-updated-message-max": "Быстрая покупка не может быть больше {{amount}}",
  "trade-settings.quick-buy-title": "Настройки быстрой покупки",
  "trade-settings.quick-buy.section.cooking": "Таблица готовящихся",
  "trade-settings.quick-buy.section.explore-feeds": "Списки изучения",
  "trade-settings.quick-buy.section.new-pairs": "Таблица новых пар",
  "trade-settings.quick-buy.section.trending": "Таблица трендов",
  "trade-settings.quick-buy.section.wallet-tracker": "Трекера кошельков",
  "trade-settings.rpc-endpoint": "RPC Эндпоинт",
  "trade-settings.zero-slot-description": "Отправка через 0slot",
  "trade-settings.zero-slot-tooltip": "Премиум tx sender. Требует API ключ от 0slot.trade",
  "trade-settings.zero-slot.api-key-placeholder": "Ваш API ключ от 0slot.trade",
  "trade.button.edit": "Редактировать",
  "trade.buy-first": "Первая покупка",
  "trade.buy-more": "Докупка",
  "trade.cancelled-at": "Отменён в",
  "trade.chart.open-transactions-error": "Не удалось открыть все транзакции",
  "trade.chart.open-transactions-error-description": "Разрешите всплывающие окна и переадресацию для этого сайта, чтобы открывать несколько вкладок с транзакциями.",
  "trade.completed-at": "Завершен в",
  "trade.entry-price": "Цена Входа",
  "trade.expire-date": "Дата окончания",
  "trade.expired": "Истёк",
  "trade.expired-at": "Истёк в",
  "trade.expires-in": "Истечёт через {{interval}}",
  "trade.failed-at": "Не удался в",
  "trade.filters.common.apply": "Применить",
  "trade.filters.common.reset": "Сбросить",
  "trade.filters.maker.header": "Фильтровать по трейдеру",
  "trade.filters.maker.label": "Введите Трейдера",
  "trade.filters.maker.trigger": "Трейдер",
  "trade.filters.total.header": "Фильтровать по Всего {{currency}}",
  "trade.holders-charts.holders": "Холдеры",
  "trade.holders-charts.snipers_holding": "Доля снайперов %",
  "trade.holders-charts.top_10_holders": "Топ 10 Холдеров",
  "trade.instant-trade": "Моментальный Трейд",
  "trade.liquidity-short": "Ликвид",
  "trade.market-cap-short": "Кап",
  "trade.my-trades": "Мои Трейды",
  "trade.pair-information.fees-paid": "Комиссии",
  "trade.pair-information.freeze": "Фриз",
  "trade.pair-information.mint": "Минт",
  "trade.pnl.share.title": "Поделиться PnL",
  "trade.pnl.sold-all": "Продано",
  "trade.price-short": "Ц",
  "trade.quick-buy.min-amount-amount": "Минимальная получаемая сумма",
  "trade.sell-all": "Продал все",
  "trade.sell-partial": "Продал часть",
  "trade.slippage": "Проскальзывание",
  "trade.slippage_tooltip": "Максимальная разница между ожидаемой и настоящей ценой во время волатильности рынка. Высокое проскальзывание позволяет трейдам исполняться легче но может привести к худшему курсу.",
  "trade.stop-loss": "Стоп-Лосс",
  "trade.stop-loss-short": "СЛ",
  "trade.table.new-data": "Новые трейды",
  "trade.table.new-pairs": "Новые пары",
  "trade.table.new-trades": "Новые трейды",
  "trade.take-profit": "Тейк-Профит",
  "trade.take-profit-short": "ТП",
  "trade.target-mcap": "Цель Капитализации",
  "trade.target-price": "Цель Цены",
  "trade.trade-panel": "Panel",
  "trade.trigger-price": "Сработает при",
  "trade.type.tooltip.burn": "Токены были сожжены",
  "trade.type.tooltip.buy": "Покупка",
  "trade.type.tooltip.liquidityAdd": "Ликвидность добавлена в пул",
  "trade.type.tooltip.liquidityRemove": "Ликвидность убрана из пула",
  "trade.type.tooltip.lpBurn": "LP токены были сожжены",
  "trade.type.tooltip.poolInit": "Пул Инициализирован",
  "trade.type.tooltip.poolMigrate": "Пул Мигрирован",
  "trade.type.tooltip.sell": "Продажа",
  "trading": "Торговля",
  "trading-activity": "Торговая Активность",
  "trading-activity.description": "Отслеживайте Вашу стабильность и PnL",
  "trading.add_funds": "Добавить Активы",
  "trading.approve-tokens": "Одобрить токены",
  "trading.approving-tokens": "Токены одобряются",
  "trading.audit.bot_users": "Боты",
  "trading.audit.bundlers_holding": "Бандлеры",
  "trading.audit.bundlers.holding-tooltip": "Бандлеры держат {{percentage}}% от общего предложения",
  "trading.audit.button_proceed": "Перейти к трейду",
  "trading.audit.ca_deployer": "Создатель КА",
  "trading.audit.deployer_address": "Адрес Создателя",
  "trading.audit.description": "Если Вы перейдёте к торговле, делайте это с осторожностью и изучите аудит безопасности внимательно.",
  "trading.audit.dev_bought_tooltip": "Разраб. Купил {{timeAt}} назад",
  "trading.audit.dev_holding": "Разраб.",
  "trading.audit.dev_holding_tooltip": "Разраб. Удерживает {{percentage}}%",
  "trading.audit.dev_holding.short": "Разраб.",
  "trading.audit.dev_migrations": "Dev Migrations",
  "trading.audit.dev_sold_tooltip": "Разраб. Продал {{timeAt}} назад",
  "trading.audit.holders_tooltip": "Количество холдеров",
  "trading.audit.insider_holding": "Инсайдеры",
  "trading.audit.insider_holding_tooltip": "Инсайдеры удерживают {{percentage}}% от общего предложения",
  "trading.audit.is_freezable": "Заморозка?",
  "trading.audit.is_mintable": "Чеканка?",
  "trading.audit.is_mintable.hint": "Проверка сохраняется ли право чеканки новых токенов",
  "trading.audit.is_token_data_mutable": "Данные Токена Изменяемы?",
  "trading.audit.is_token_data_mutable.hint": "Проверка являются ли данные токена изменяемыми",
  "trading.audit.is-freezable.warning-tooltip": "Токен можно заморозить",
  "trading.audit.is-mintable.warning-tooltip": "Чеканка токена включена",
  "trading.audit.lp_burned": "ЛП Сожжён",
  "trading.audit.lp_burned.hint": "Токены Пула Ликвидности которые были сожжены",
  "trading.audit.lp_burned.tooltip-percentage": "{{percents}} токенов ЛП были сожжены",
  "trading.audit.lp_creator": "Создатель ЛП",
  "trading.audit.lp-burned.warning-tooltip": "LP сожжена не полностью ({{burnedPercent}}%)",
  "trading.audit.not_show_again": "Больше не показывать",
  "trading.audit.owner_balance": "Баланс Владельца",
  "trading.audit.snipers": "Снайперы",
  "trading.audit.snipers_holding": "Снайперы",
  "trading.audit.snipers_tooltip": "Количество снайперов",
  "trading.audit.snipers.holding-tooltip": "Снайперы удерживают {{percentage}}% от циркуляции",
  "trading.audit.title": "Проблем с Безопасностью Не Обнаружено",
  "trading.audit.title_warnings_few": "{{count}} Проблемы с Безопасностью Обнаружено",
  "trading.audit.title_warnings_many": "{{count}} Проблем с Безопасностью Обнаружено",
  "trading.audit.title_warnings_one": "{{count}} Проблема с Безопасностью Обнаружена",
  "trading.audit.title_warnings_other": "{{count}} Проблем с Безопасностью Обнаружено",
  "trading.audit.title_warnings_zero": "Проблем с Безопасностью Не Обнаружено",
  "trading.audit.top_10_holders": "Топ 10 Холдеров",
  "trading.audit.top_10_holders_tooltip": "Топ 10 Холдеров удерживают {{percentage}}% от циркуляции",
  "trading.audit.top_10_holders.hint": "Процент Циркуляции, удерживаемый Топ 10 Холдерами",
  "trading.audit.top_10_holders.short": "Топ 10 Х.",
  "trading.audit.update_authority": "Право Обновления",
  "trading.audit.update_authority.none": "Нет",
  "trading.buy": "Купить",
  "trading.buy-quote-for": "Купить <0 /> <1 /> за <2 />",
  "trading.buy.active-title": "Покупка <amount /> в обработке",
  "trading.buy.error-title": "Не удалось купить {{ticker}}",
  "trading.buy.success-title": "Успешно куплено <amount /> на <amountNative />",
  "trading.buys": "Покупки",
  "trading.check-approval": "Проверить одобрение",
  "trading.check-approval-error": "Не удалось проверить одобрение. Попробуйте ещё раз.",
  "trading.checking-approval": "Одобрение проверяется",
  "trading.deluge_trending": "kol.trade Тренды",
  "trading.dev-burn.burnt-rate": "Сожжено",
  "trading.dev-burn.dev-burnt": "Разраб. сжег",
  "trading.dev.short": "Разраб.",
  "trading.error.insufficient-funds": "Недостаточный баланс {{ticker}}",
  "trading.error.no-amount": "Введите сумму",
  "trading.error.no-currency": "Выберите токен",
  "trading.error.no-route": "Нет доступных маршрутов",
  "trading.favorites.added": "{{ticker}} добавлено в избранное",
  "trading.favorites.empty-description": "И следите за его изменениями",
  "trading.favorites.empty-title": "Добавьте первый токен в ваш список наблюдения",
  "trading.favorites.error": "Что-то пошло не так во время добавления/удаления из избранного",
  "trading.favorites.removed": "{{ticker}} удалён из избранного",
  "trading.gas": "Газ",
  "trading.limit_buy": "Лимитная покупка",
  "trading.limit_order": "Лимитный ордер",
  "trading.limit_sell": "Лимитная продажа",
  "trading.limit-buy": "Лимитная покупка",
  "trading.limit-order.order-error": "Ордер не удался",
  "trading.limit-order.order-error-description": "Мы не смогли разместить Ваш ордер из-за ошибки. Пожалуйста, попробуйте ещё раз или свяжитесь с поддержкой если проблема сохраняется.",
  "trading.limit-order.order-placed": "Ордер успешно размещён!",
  "trading.limit-order.order-placed-description": "Ваш ордер был успешно размещён. Вы можете отследить прогресс во вкладке Ордера.",
  "trading.limit-order.processing-order": "Ордер в Процессе",
  "trading.limit-order.processing-order-description": "Ваш ордер в процессе обработки. Это может занять некоторое время, пожалуйста, подождите.",
  "trading.limit-rate-by": "Сортировать по",
  "trading.limit-sell": "Лимитная продажа",
  "trading.low-liquidity-alert": "У этой пары очень мало ликвидности",
  "trading.market-buy": "Рыночная покупка",
  "trading.market-cap": "Капитализация",
  "trading.market-order.processing-transaction": "Транзакция в Процессе",
  "trading.market-order.processing-transaction-description": "Ваша транзакция в процессе обработки. Это может занять некоторое время, пожалуйста, подождите.",
  "trading.market-order.transaction-error": "Транзакция не Удалась",
  "trading.market-order.transaction-error-description": "Мы не смогли отправить Вашу транзакцию из-за ошибки. Пожалуйста, попробуйте ещё раз или свяжитесь с поддержкой если проблема сохраняется.",
  "trading.market-order.transaction-placed": "Транзакция была выполнена!",
  "trading.market-order.transaction-placed-description": "Ваша транзакция была успешно выполнена. Вы можете найти больше информации в истории транзакций.",
  "trading.market-sell": "Рыночная продажа",
  "trading.mev_protection": "Защита от MEV",
  "trading.navigation.favorites": "Избранные",
  "trading.navigation.last-pairs": "Последние пары",
  "trading.navigation.limit_orders": "Лимитные Ордера",
  "trading.navigation.orders": "Ордера",
  "trading.navigation.positions": "Позиции",
  "trading.navigation.search": "Поиск",
  "trading.navigation.wallets": "Кошельки",
  "trading.no-wallet-title": "Создайте первый кошелёк чтобы начать торговать",
  "trading.order.amount": "Сумма",
  "trading.order.bribe-tooltip": "Чаевые",
  "trading.order.dca": "DCA",
  "trading.order.gas-priority-fee-tooltip": "Приоритетная Комиссия за Газ",
  "trading.order.limit": "Лимитный",
  "trading.order.market": "Рыночный",
  "trading.order.slippage-percentage-tooltip": "Процент Проскальзывания",
  "trading.order.token-orders": "Ордеры токена",
  "trading.orders.no-orders.active": "У Вас нет активных ордеров",
  "trading.orders.no-orders.cancelled": "У Вас нет отменённых ордеров",
  "trading.orders.no-orders.completed": "У Вас нет невыполненных ордеров",
  "trading.orders.no-orders.expired": "У Вас нет истёкших ордеров",
  "trading.orders.no-orders.failed": "У Вас нет неудавшихся ордеров",
  "trading.orders.no-orders.sub-title": "Ваши лимитные ордера появятся здесь",
  "trading.orders.no-orders.title": "У Вас нет ордеров",
  "trading.orders.view-all": "Вы можете просмотреть все лимитные ордера здесь",
  "trading.pair.address-copied-to-clipboard": "Адрес пары был скопирован!",
  "trading.pair.buy_volume": "Объем покупок",
  "trading.pair.buyers": "Покупатели",
  "trading.pair.buys": "Покупки",
  "trading.pair.makers": "Мейкеры",
  "trading.pair.sell_volume": "Объем продаж",
  "trading.pair.sellers": "Продавцы",
  "trading.pair.sells": "Продажи",
  "trading.pair.share-link-copied": "Ссылка была скопирована!",
  "trading.pair.tx": "Транз.",
  "trading.pair.volume": "Объем",
  "trading.parameters.avg_wait_time": "Ср. Время Ожидания",
  "trading.parameters.deadline": "Дедлайн",
  "trading.parameters.fee": "Комиссия",
  "trading.parameters.max_slippage": "Макс. Проскальзывание",
  "trading.parameters.minimum_receive": "Мин. К Получению",
  "trading.parameters.network_cost": "Комиссия Сети",
  "trading.parameters.platform_fee": "Комиссия Платформы",
  "trading.parameters.price_impact": "Влияние На Цену",
  "trading.parameters.rate": "Курс",
  "trading.place-order": "Разместить Ордер",
  "trading.position.invested": "Куплено",
  "trading.position.pnl_change": "Изменение PnL",
  "trading.position.remaining": "Осталось",
  "trading.position.sold": "Продано",
  "trading.position.stop-loss-at": "Стоп-Лосс на",
  "trading.position.unrealized": "Нереализованный",
  "trading.position.unrealized-pnl": "Нереализованный PnL",
  "trading.positions.no-positions.sub-title": "Ваши позиции будут здесь",
  "trading.positions.no-positions.title": "У Вас нет позиций",
  "trading.positions.not-set": "Нет",
  "trading.positions.view-all.title": "Вы можете просмотреть позиции здесь",
  "trading.quick_trade": "Быстрый Трейд",
  "trading.quote-pending": "Расчёт",
  "trading.quote-retry": "Получить расчёт",
  "trading.quote.not-enough-liquidity": "Недостаточно ликвидности",
  "trading.rate-by": "Сортировать по",
  "trading.rate-by.market-cap": "Капитализация",
  "trading.rate-by.market-cap-is": "Капитализация",
  "trading.rate-by.price": "Цена",
  "trading.rate-by.price-is": "Цена",
  "trading.rate-by.rate-by-market-cap": "Сортировать по Кап.",
  "trading.rate-by.rate-by-price": "Сортировать по Цене",
  "trading.recent_pairs": "Недавние Пары",
  "trading.recent-pairs.no-recent-pairs.sub-title": "Ваши недавно торгованные пары будут отображены здесь",
  "trading.recent-pairs.no-recent-pairs.title": "У Вас нет недавних пар!",
  "trading.recent-pairs.view-all": "Вы можете увидеть недавние пары здесь",
  "trading.search.recent-searches": "Недавние Поиски",
  "trading.search.recent-searches.empty": "У Вас нет недавних поисков",
  "trading.sell": "Продать",
  "trading.sell-all": "Продать Все",
  "trading.sell-all-positions": "Продать все позиции",
  "trading.sell-all-positions-description": "Вы уверены, что хотите продать все позиции {{ticker}}?",
  "trading.sell-amount": "Сумма продажи",
  "trading.sell-high": "Высокая продажа",
  "trading.sell-low": "Низкая продажа",
  "trading.sell-position-snackbar.failed": "Продажа позиций не удалась",
  "trading.sell-position-snackbar.pending": "Продажа позиций в процессе",
  "trading.sell-position-snackbar.success": "Позиции проданы успешно",
  "trading.sell-position-snackbar.successSome": "Позиции проданы частично",
  "trading.sell-quote-for": "Продать <0 /> <1 /> за <2 />",
  "trading.sell.active-title": "Продажа <amount /> в обработке",
  "trading.sell.error-title": "Не удалось продать {{ticker}}",
  "trading.sell.success-title": "Успешно продано <amount />",
  "trading.sells": "Продажи",
  "trading.stop_loss": "Стоп-Лосс",
  "trading.swap": "Обменять",
  "trading.swap.error-title": "Транзакция не удалась",
  "trading.swap.getting-quote-description": "Расчет котировки",
  "trading.swap.processing-title": "Обработка транзакции",
  "trading.swap.success-title": "Транзакция успешно выполнена",
  "trading.take_profit": "Тейк-Профит",
  "trading.tokens-approve-error": "Не получилось одобрить токены",
  "trading.tokens-approve-error.insufficient": "Недостаточно средств чтобы одобрить токены. Пополните кошелёк чтобы покрыть траты на газ.",
  "trading.tokens-approved-message": "Токены были одобрены",
  "trading.transaction-confirmation-failed.message": "Транзакция не подтверждена",
  "trading.transaction-confirmed.message": "Транзакция подтверждена",
  "trading.you_pay": "Вы Заплатите",
  "trading.you_receive": "Вы Получите",
  "trading.you_will_pay": "Вы заплатите",
  "transaction_few": "Транзакции",
  "transaction_many": "Транзакций",
  "transaction_one": "Транзакция",
  "transaction_other": "Транзакции",
  "transaction_zero": "Транзакций",
  "transaction.block_number": "Номер блока",
  "transaction.history": "История транзакций",
  "transaction.history.empty-description": "Ваши транзакции будут отображены здесь",
  "transaction.history.empty-description.another": "Транзакции пользователя будут отображены здесь",
  "transaction.history.empty-title": "История транзакций пуста",
  "transaction.nonce": "Nonce",
  "transaction.see_in_explorer": "Открыть Обозреватель",
  "transaction.sent-to": "Отправлено на",
  "transaction.status_active": "Активная",
  "transaction.status_all": "Все статусы",
  "transaction.status_cancelled": "Отменённая",
  "transaction.status_failed": "Неудачная",
  "transaction.status_finished": "Завершённая",
  "transaction.status_pending": "В обработке",
  "transaction.status_success": "Успешная",
  "transaction.transaction_details": "Детали транзакции",
  "transaction.transaction_hash_copied_message": "Хеш транзакции {{hash}} скопирован в буфер обмена!",
  "transaction.transactions_all": "Все транзакции",
  "transaction.type_buy": "Покупка",
  "transaction.type_deposit": "Получение",
  "transaction.type_sell": "Продажа",
  "transaction.type_swap": "Обмен",
  "transaction.type_transfer": "Перевод",
  "transactions": "Транзакции",
  "transfer": "Перевод",
  "transfer.amount-plus-gas-fee": "Сумма + комиссия за газ",
  "transfer.balance-after": "Баланс после",
  "transfer.error": "Не получилось произвести перевод",
  "transfer.estimated-changes": "Предполагаемые изменения",
  "transfer.max-amount": "Макс. сумма",
  "transfer.send-to": "отправить на",
  "transfer.transfer-processing": "В процессе...",
  "transfer.transfer-processing-message": "Транзакция в процессе! Валидация транзакции блокчейном. Это может занять несколько минут. Вы всегда можете проверить статус в истории транзакций",
  "transfer.validation.insufficient-funds": "У Вас недостаточно {{ticker}} чтобы отправить",
  "transfer.you-send": "Вы отправляете",
  "trending": "Тренды",
  "trending.loading-error": "Не удалось загрузить тренды. Пожалуйста, попробуйте позже.",
  "unsafe-url-dialog.beware-of-phishing-scams": "Будьте осторожны с фишинговыми схемами:",
  "unsafe-url-dialog.continue-on": "Продолжить в",
  "unsafe-url-dialog.description": "Будьте Осторожны",
  "unsafe-url-dialog.dont-show-this-warning-again": "Не показывать это предупреждение снова",
  "unsafe-url-dialog.i-understand": "Я понимаю",
  "unsafe-url-dialog.if-something-feels-off": "Если что-то не так, не взаимодействуйте и обратитесь к нам в Telegram или Discord",
  "unsafe-url-dialog.never-connect-your-wallet": "Никогда не подключайте свой кошелек или подтверждайте транзакции, если вы не уверены на 100% в легитимности источника",
  "unsafe-url-dialog.never-enter-your-credentials": "Никогда не вводите ваши Discord или Telegram учетные данные, чтобы доказать, что вы не бот",
  "unsafe-url-dialog.protect-your-wallet": "Защитите ваш кошелек:",
  "unsafe-url-dialog.title": "Предупреждение",
  "unsafe-url-dialog.when-in-doubt-stop": "Когда в сомнении, остановитесь!:",
  "update.about": "Об обновлении",
  "update.download_error_message": "Ошибка загрузки обновления",
  "update.installation_error_message": "Ошибка установки обновления",
  "update.latest_update_message": "Новых обновлений нет",
  "update.latest_update_title": "Установлено последнее обновление",
  "update.new_version_available": "Доступна новая версия: {{version}}",
  "update.new_version_message": "Скачайте и установите приложение",
  "update.relaunch_error_message": "Ошибка перезагрузки приложения",
  "update.update_available": "Доступна новая версия приложения",
  "update.update_check_error_message": "Ошибка проверки обновления",
  "update.update_checking": "Проверка обновления",
  "update.update_ready": "Обновление скачано",
  "update.update_ready_message": "После установки приложение перезапустится и изменения вступят в силу",
  "validation.file-too-large": "Файл слишком большой",
  "validation.invalid_address": "Неверный адрес",
  "validation.max_length": "Максимальное количество символов {{length}}",
  "validation.required": "Обязательно",
  "wallet_few": "кошелька",
  "wallet_many": "кошельков",
  "wallet_one": "кошелёк",
  "wallet_other": "кошельки",
  "wallet_zero": "Кошельков",
  "wallet-manager.add_color": "Добавить цвет",
  "wallet-manager.edit.title": "Редактировать Кошелёк",
  "wallet-manager.hidden-assets": "Скрытые Активы",
  "wallet-manager.page.title": "Управление Кошельками",
  "wallet-profile.activity.bought": "Купил",
  "wallet-profile.activity.sold": "Продал",
  "wallet-profile.bucket.gain-0-200": "0 – 200%",
  "wallet-profile.bucket.gain-200-500": "200 – 500%",
  "wallet-profile.bucket.gain-over-500": "Больше 500%",
  "wallet-profile.bucket.loss-0-50": "0 – -50%",
  "wallet-profile.bucket.loss-over-50": "Меньше -50%",
  "wallet-profile.tab.degen-hours": "Часы азарта",
  "wallet-profile.degen-hours.note": "Каждый квадрат — средняя прибыль одной сделки в этот час по вашему времени. Час без сделок остаётся пустым.",
  "wallet-profile.degen-hours.over-trades": "за {{count}} сделок",
  "wallet-profile.degen-hours.win-rate": "{{rate}}% прибыльных",
  "wallet-profile.degen-hours.best": "Лучший час",
  "wallet-profile.degen-hours.average": "Средняя",
  "wallet-profile.degen-hours.per-trade": "/ сделка",
  "wallet-profile.degen-hours.days": "за {{days}} дн.",
  "wallet-profile.column.action": "Действие",
  "wallet-profile.column.amount": "Сумма",
  "wallet-profile.column.asset": "Актив",
  "wallet-profile.column.counterparty": "Контрагент",
  "wallet-profile.column.detail": "Токен / Кошелёк",
  "wallet-profile.column.time": "Время",
  "wallet-profile.column.value": "В USD",
  "wallet-profile.column.value-note": "Пересчёт по сегодняшней цене, а не по цене на тот момент.",
  "wallet-profile.consistency": "Стабильность",
  "wallet-profile.consistency-tooltip": "Реализованный PnL относительно его же дневного разброса. Выше — ровнее, а не больше.",
  "wallet-profile.funding.by": "Пополнен с",
  "wallet-profile.funding.unknown": "Первое пополнение неизвестно — кошелёк торговал ещё до того, как мы начали смотреть",
  "wallet-profile.tab.activity": "Активность",
  "wallet-profile.tab.transfers": "Переводы",
  "wallet-profile.transfers.empty": "За последние {{days}} дн. денег не двигалось",
  "wallet-profile.transfers.in": "Получил",
  "wallet-profile.transfers.note": "SOL и стейблы, последние {{days}} дн. Переводы токенов не индексируются.",
  "wallet-profile.transfers.out": "Отправил",
  "wallet-profile.not-enough-days": "Пока мало дней для графика",
  "wallet-profile.positions": "Позиции",
  "wallet-profile.realized-over-time": "Реализованный PnL, 30 дней",
  "wallet-profile.received": "Получено",
  "wallet-profile.spent": "Потрачено",
  "wallet-profile.title": "Профиль кошелька",
  "wallet-profile.tab.dev-tokens": "Выпущенные",
  "wallet-profile.tab.history": "История",
  "wallet-profile.tab.positions": "Активные позиции",
  "wallet-profile.tab.top": "Топ 100",
  "wallet-profile.token": "Токен",
  "wallet-profile.tokens-traded": "Токенов в работе",
  "wallet-profile.trades": "Сделок",
  "wallet-profile.unpriced": "Стоимость не записана",
  "wallet-profile.unpriced-note": "Токен куплен в пуле, который не сообщил цену, поэтому прибыль по нему неизвестна, а не равна нулю.",
  "wallet-tracker": "Трекер Кошельков",
  "wallet-tracker.add-wallet.button": "Добавить",
  "wallet-tracker.add-wallet.success": "Кошелёк успешно добавлен для отслеживания!",
  "wallet-tracker.add-wallet.title": "Добавить кошелёк",
  "wallet-tracker.alerts": "Уведомления",
  "wallet-tracker.delete-wallet.success": "Кошелёк успешно удален из отслеживания!",
  "wallet-tracker.dialog.title": "Трекер",
  "wallet-tracker.edit-wallet.success": "Кошелек успешно отредактирован",
  "wallet-tracker.filter.tags.name": "Фильтры по тегам",
  "wallet-tracker.filter.tags.placeholder": "Введите тег",
  "wallet-tracker.following": "Отслеживание",
  "wallet-tracker.monitor-square": "Мониторинг",
  "wallet-tracker.new-alerts": "Новые уведомления",
  "wallet-tracker.notification.wallet-buy-more.description": "Кошелёк {{label}} докупил {{amount}} {{ticker}} при {{mcap}} Кап. Баланс: {{balance}} {{ticker}}.",
  "wallet-tracker.notification.wallet-buy-more.title": "Кошелёк {{label}} докупил {{ticker}}",
  "wallet-tracker.notification.wallet-first-buy.description": "Кошелёк {{label}} впервые купил {{amount}} {{ticker}} при {{mcap}} Кап.",
  "wallet-tracker.notification.wallet-first-buy.title": "Кошелёк {{label}} купил {{ticker}}",
  "wallet-tracker.notification.wallet-sell-full.description": "Кошелёк {{label}} продал все {{amount}} {{ticker}} при {{mcap}} Кап.",
  "wallet-tracker.notification.wallet-sell-full.title": "Кошелёк {{label}} продал все {{ticker}}",
  "wallet-tracker.notification.wallet-sell-partial.description": "Кошелёк {{label}} продал {{amount}} {{ticker}} при {{mcap}} Кап. Остаток: {{balance}} {{ticker}}.",
  "wallet-tracker.notification.wallet-sell-partial.title": "Кошелёк {{label}} частично продал {{ticker}}",
  "wallet-tracker.page.title": "Трекер Кошельков",
  "wallet-tracker.port.export-description": "Ваши кошельки будут экспортированы сюда",
  "wallet-tracker.port.export-error": "Не удалось скачать файл экспорта",
  "wallet-tracker.port.export-success": "Файл экспорта успешно скачан",
  "wallet-tracker.port.import-description": "Введите адреса кошельков для импорта",
  "wallet-tracker.port.import-partial-success": "Импортировано кошельков: {{count}}, пропущено: {{skipped}}",
  "wallet-tracker.port.import-success": "Кошельки({{count}}) были успешно импортированы",
  "wallet-tracker.port.import.choose-file": "Выбрать файл",
  "wallet-tracker.port.import.wrong-format": "Неверный формат импорта",
  "wallet-tracker.port.tab.export": "Экспорт",
  "wallet-tracker.port.tab.import": "Импорт",
  "wallet-tracker.port.title": "Экспорт/Импорт кошельков",
  "wallet-tracker.table.alert": "Уведомления",
  "wallet-tracker.table.label": "Название",
  "wallet-tracker.table.tags": "Теги",
  "wallet-tracker.wallet-address.placeholder": "Введите адрес кошелька",
  "wallet-tracker.wallet-name.placeholder": "Введите название кошелька",
  "wallet-tracker.wallet-tags.placeholder": "Введите теги кошелька",
  "wallet.add_wallet": "Добавить кошелёк",
  "wallet.address_copied_snackbar": "Адрес кошелька скопирован!",
  "wallet.address_input_placeholder": "Введите адрес кошелька",
  "wallet.all_wallets": "Все кошельки",
  "wallet.change_wallet_color": "Изменить цвет кошелька",
  "wallet.create.create-new-wallet": "Создать кошелёк",
  "wallet.create.new-wallet": "Новый Кошелёк",
  "wallet.create.seed-phrase-check-boxes": "Отметьте все галочки, подтверждая что Вы понимаете важность секретной фразы",
  "wallet.create.seed-phrase-title": "Эта фраза обеспечивает доступ к кошельку",
  "wallet.create.seed-phrase-warning": "Никогда не делитесь секретной фразой и храните её в надёжном месте.",
  "wallet.create.seed-phrase-words-selection-description": "Выберите слова секретной фразы по порядковому номеру",
  "wallet.create.success-message": "Новый кошелёк успешно создан",
  "wallet.create.word": "Слово",
  "wallet.delete_confirmation.description": "Вы собираетесь удалить кошелёк. Это навсегда удалит кошелёк и доступ к нему с этого устройства будет потерян",
  "wallet.delete_confirmation.subtitle": "Вы точно хотите удалить кошелёк?",
  "wallet.delete_wallet": "Удалить кошелёк",
  "wallet.delete_wallet.failure": "Не удалось удалить кошелёк {{walletName}}",
  "wallet.delete_wallet.success": "Кошелёк {{walletName}} был успешно удалён",
  "wallet.deleting_a_wallet": "Удаление кошелька",
  "wallet.deposit": "Пожалуйста, пополняйте только с кошелька {{network}}, чтобы ваши средства не были потеряны.",
  "wallet.distribute": "Распределить",
  "wallet.distribute.add-wallet": "Добавить кошелёк",
  "wallet.distribute.add-wallets": "Добавить кошельки",
  "wallet.distribute.error.insufficient-balance": "Недостаточный баланс",
  "wallet.distribute.error.no-targets": "Выберите получателей",
  "wallet.distribute.error.no-wallet": "Выберите кошелёк",
  "wallet.distribute.header-description": "Выберите кошелёк и токен для распределения",
  "wallet.distribute.processing-title": "Обработка распределения токенов",
  "wallet.distribute.select-asset": "Выберите актив",
  "wallet.distribute.unlock-tooltip": "Сумма зафиксирована. Нажмите на значок замка, чтобы включить авторасчёт.",
  "wallet.export_wallet": "Экспорт кошелька",
  "wallet.export_wallet.copied-note": "{{subject}} скопирован в буфер обмена!",
  "wallet.export_wallet.description": "Перед просмотром секретной фразы, внимательно прочтите информацию.",
  "wallet.export_wallet.do_not_share_recovery_phrase": "Поддержка kol.trade никогда не спрашивает секретную фразу.",
  "wallet.export_wallet.recovery_phrase_warning": "Каждый с этой секретной фразой получит доступ к Вашему кошельку.",
  "wallet.export_wallet.storing_warning": "Запишите секретную фразу оффлайн и сохраните её в надёжном месте.",
  "wallet.favorite": "Избранные",
  "wallet.funds-management": "Управление средствами",
  "wallet.import_wallet": "Импорт кошелька",
  "wallet.import.already-exists": "Кошелёк уже существует",
  "wallet.import.enter_your_private_key": "Введите приватный ключ",
  "wallet.import.enter_your_secret_phrase": "Введите секретную фразу",
  "wallet.import.error": "Не удалось импортировать кошелёк",
  "wallet.import.invalid-private-key": "Неверный приватный ключ",
  "wallet.import.invalid-seed-phrase": "Неверная секретная фраза",
  "wallet.import.name": "Введите название кошелька",
  "wallet.import.phrase_hint": "Обычно 12 (иногда 18, 24) слов разделённые пробелом",
  "wallet.import.phrase-hint-ton": "12 или 24 слова разделённые пробелом",
  "wallet.import.success": "Кошелёк успешно импортирован",
  "wallet.instant_dialog.no_wallets": "Здесь нет кошельков",
  "wallet.instant_dialog.open_first": "создайте Ваш первый",
  "wallet.list-wallets.error.description": "Непредвиденная ошибка при загрузке кошельков",
  "wallet.list-wallets.error.title": "Не удалось загрузить кошельки",
  "wallet.manage-assets": "Управлять активами",
  "wallet.no_favorite_wallets_message": "У Вас нет избранных кошельков",
  "wallet.no_wallets_description": "Это не сложно и Вы можете легко создать кошелёк ниже",
  "wallet.no_wallets_title": "Вы ещё не создали ни одного кошелька",
  "wallet.no_wallets.banner.sub-title": "создайте кошелёк для полного доступа к функциям",
  "wallet.no_wallets.banner.title": "Начните Торговать Сейчас!",
  "wallet.open_wallet": "Создать кошелёк",
  "wallet.operations": "Операции Кошелька",
  "wallet.phrase": "Фраза",
  "wallet.private_key": "Приватный Ключ",
  "wallet.refresh-wallet": "Обновить Кошелёк",
  "wallet.rename_wallet": "Переименовать кошелёк",
  "wallet.rename_wallet_short": "Переименовать",
  "wallet.reorder_wallets.failure": "Не удалось изменить порядок кошельков",
  "wallet.reorder-aria-label": "Изменить порядок кошелька",
  "wallet.search_by_name_address": "Название кошелька или адрес...",
  "wallet.search-wallet": "Искать кошелёк",
  "wallet.secret_phrase": "Секретная фраза",
  "wallet.select_wallet": "Выберите Кошелёк",
  "wallet.stats.daily_flow": "Ежедневный поток",
  "wallet.stats.summary": "Сводка",
  "wallet.stats.top_profit": "Максимальная прибыль",
  "wallet.updated_error": "Не удалось обновить {{wallet}}",
  "wallet.updated_success": "{{wallet}} был обновлён!",
  "wallet.wallet_color": "Цвет кошелька",
  "wallet.wallet_name": "Название кошелька",
  "wallet.your_assets": "Ваши Активы",
  "withdraw": "Вывод"
}
